export default {
	one: "一",
	two: "二",
	three: "三",
	four: "四",
	five: "五",
	six: "六",
	seven: "七",
	eight: "八",
	nine: "九",
	ten: "十",
	"index_nihao":"こんにちは、{0}",
	"index_jipiao":"航空券",
	"index_jiudianzhusu":"ホテル宿泊",
	"index_huoche":"電車",
	"index_lvyoudujia":"旅行・リゾート",
	"index_shangwuyonche": "ビジネス用車両",
	"index_jinqixingcheng": "近日の旅程",
	"index_zhi":"まで",
	"index_jian":"間",
	"index_qushenpi":"承認へ",
	"index_xiangqing":"詳細",
	"index_jiantizhongwen":"簡体字中国語",
	"index_jijiangchengxian":"まもなく公開！",
	"index_ditugongnengkaifazhong":"地図機能は開発中です！",
	"index_meiyoushenpidingdan":"承認待ちの注文はありません！",

	"index_jiudian":"ホテル",
	"index_huochepiao":"鉄道チケット",
	"index_yuyan":"言語",
	"index_jinqimeiyouchuxinganpai":"近々旅行の予定はありません！",
	"login_qingtianxiemima":"パスワードを入力してください",
	"login_wangjimima":"パスワードをお忘れですか",
	"login_qingshuruyanzhengma":"認証コードを入力してください",
	"login_fasongyanzhengma":"認証コードを送信",
	"login_denglu":"ログイン",
	"login_yanzhengmadenglu":"認証コードログイン",
	"login_zhanghaomimadenglu":"アカウントパスワードログイン",
	"login_jiantizhongwen": "簡体字中国語",
	"login_yingwen": "English",
	"login_riyu": "日本語",
	"login_denglujidaibiaonintongyiwomende":"既読し、当社の",
	"login_tongyi": "同意する",
	"login_butongyituichuapp": "同意せずにアプリを終了する",
	"login_fuwuxieyi":"《サービス利用規約》",
	"login_fuwuxieyitext": "サービス利用規約",
	"login_he":"および",
	"login_byyzzbbhsyyhdgrysq": "本アプリは、すべてのユーザーの個人プライバシー権を尊重し、保護します。",
	"login_wlgntggzq": "より正確なサービスを提供するため",
	"login_gygxhdfw": "よりパーソナライズされたサービスを提供するため",
	"login_keyuedu": "閲覧可能",
	"login_byyhazyszcdgdsyhplndgrxx": "本アプリは、プライバシーポリシーの規定に従い、お客様の個人情報を使用・開示します。",
	"login_yinsizhengce":"《プライバシーポリシー》",
	"login_yinsizhengcetext": "プライバシーポリシー",
	"mall_flight_backtorule_fanhui":"戻る",
	"mall_flight_backtorule_tuigaiguize":"変更・キャンセル規定",
	"mall_flight_backtorule_goupiaoxuzhi":"チケット購入時の注意事項",
	"mall_flight_backtorule_nulihuoquzhong":"取得中...",
	"mall_flight_flight_chufadi":"出発地",
	"mall_flight_flight_mudedi":"目的地",
	"mall_flight_flight_chufashijian":"出発時間",
	"mall_flight_flight_fanchengshijian":"帰りの時間",
	"mall_flight_flight_cangwei":"クラス",
	"mall_flight_flight_tianjialvke":"搭乗者を追加",
	"mall_flight_flight_dianjixuanzelvke":"クリックして搭乗者を選択",
	"mall_flight_flight_dianjixuanzecangwei": "クリックしてクラスを選択",
	"mall_flight_flight_sousuo":"検索",
	"mall_flight_flight_ruxuyudingertongyingerpiaoqinglianxibengongsikefu":"お子様/幼児の航空券を予約する場合は、当社のカスタマーサービスまでご連絡ください。",
	"mall_flight_flight_toudengcang":"ファーストクラス",
	"mall_flight_flight_shangwucang":"ビジネスクラス",
	"mall_flight_flight_jingjicang":"エコノミークラス",
	"mall_flight_flight_chaojijingjicang": "プレミアムエコノミー",
	"mall_flight_flight_dancheng":"片道",
	"mall_flight_flight_wangfan":"往復",
	"mall_flight_flight_shanghai":"上海",
	"mall_flight_flight_beijing":"北京",
	"mall_flight_flight_guangzhou":"広州",
	"mall_flight_flight_yueri":"MM月DD日",
	"mall_flight_flight_qingxuanzelvke":"搭乗者を選択してください",
	"mall_flight_flight_shenpidanhangcheng": "出発到着都市には、該当する承認書のフライト旅程が1つ必要です！",
    "mall_flight_flight_shenpidanchufariqi": "出発日は承認書の日付範囲内である必要があります！",
    "mall_flight_flight_shenpidanchufadaoda": "出発/帰着日は承認書の日付範囲内である必要があります！",
    "mall_flight_flight_shenpidanmudichengshi": "目的都市は承認書の旅程に属している必要があります！",
	"mall_flight_flight_lvkexinxiqueren": "旅客情報確認",
	"mall_flight_flight_lvkexinming": "旅客氏名",
	"mall_flight_flight_lvkezhengjian": "旅客身分証明書",
    "mall_flight_flight_youxiaoqizhi": "有効期限",
	"mall_flight_flight_kvkexingbie": "旅客性別",
	"mall_flight_flight_chushengriqi": "生年月日",
    "mall_flight_flight_lvkeguoji": "旅客国籍",
	"mall_flight_flight_fanhuixiugai": "戻って修正",
    "mall_flight_flight_querenwuwu": "確認済み、間違いなし",
	"mall_flight_flight_xiangqing": "詳細",
	"mall_flight_flightchangeinfos_gaiqian":"変更",
	"mall_flight_flightchangeinfos_yuanhangbanxinxi":"元のフライト情報",
	"mall_flight_flightchangeinfos_di":"第",
	"mall_flight_flightchangeinfos_cheng":"区間",
	"mall_flight_flightchangeinfos_yueri":"MM月DD日",
	"mall_flight_flightchangeinfos_tuigaiguize":"変更・キャンセル規定",
	"mall_flight_flightchangeinfos_xinhangbanxinxi":"新しいフライト情報",
	"mall_flight_flightchangeinfos_chuhangrenxinxi":"搭乗者情報",
	"mall_flight_flightchangeinfos_shouji":"携帯電話：163******42",
	"mall_flight_flightchangeinfos_shenfenzheng":"身分証明書：3424********0981",
	"mall_flight_flightchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"変更・キャンセル規定及び手数料基準は、実際には航空会社の定めによります",
	"mall_flight_flightchangeinfos_zongji":"合計：",
	"mall_flight_flightchangeinfos_mingxi":"明細",
	"mall_flight_flightchangeinfos_tijiaoshenhe":"審査に提出",
	"mall_flight_flightchangeinfos_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したい、もう飛びたくない",
	"mall_flight_flightchangeinfos_jicuohangchengriqishijianxingming":"旅程、日付、時間、氏名を間違えた",
	"mall_flight_flightchangeinfos_hangbanyanwuhuoquxiao":"フライトの遅延または欠航",
	"mall_flight_flightchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"貴社の出張規定に基づき、変更理由をお選びください",
	"mall_flight_flightchangeinfos_gongxinintijiaochenggongqingnaixindengdaikefuhejia":"おめでとうございます、申請が成功しました。カスタマーサービスによる価格確認までしばらくお待ちください",
	"mall_flight_flightchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie":"現在のご注文は変更できません。お電話にてカスタマーサービスまでお問い合わせください。ありがとうございます！",
	"mall_flight_flightdetails_hangbanxiangqing":"フライト詳細",
	"mall_flight_flightdetails_zhifei":"直行便",
	"mall_flight_flightdetails_yueri":"MM月DD日",
	"mall_flight_flightdetails_yixiafeiyongjunweichengrenhuoertonghuoyingerderenjunjia":"以下の料金はすべて「大人1名または子供1名または幼児1名」の一人当たり平均価格です",
	"mall_flight_flightdetails_shangwutuijian":"ビジネスおすすめ",
	"mall_flight_flightdetails_baoxian":"保険+¥{0}",
	"mall_flight_flightdetails_jinsheng":"残り{0}",
	"mall_flight_flightdetails_zhang":"枚",
	"mall_flight_flightdetails_tuigaiguize":"変更・キャンセル規定",
	"mall_flight_flightdetails_weibeiguize":"規則違反",
	"mall_flight_flightdetails_fuheguize":"ルールに合致",
	"mall_flight_flightdetails_ding":"予約",
	"mall_flight_flightdetails_tuipiaozhongkai":"払い戻し再発行",
	"mall_flight_flightdetails_tuigaishiduan":"払い戻し・変更期間",
	"mall_flight_flightdetails_tuipiaofeiyong":"払い戻し手数料",
	"mall_flight_flightdetails_gaiqianfeiyong":"変更手数料",
	"mall_flight_flightdetails_qian":"前",
	"mall_flight_flightdetails_ren":"￥{0}/人",
	"mall_flight_flightdetails_hanglie":"受託手荷物許容量",
	"mall_flight_flightdetails_yihangkonggongsizuixinguidingweizhunkezixunkefudianhua":"航空会社の最新規定に準じます。カスタマーサービスホットラインまでお問い合わせください。",
	"mall_flight_flightdetails_yscrtgqgzjfybzjgcksj":"上記の大人の払い戻し・変更規則及び手数料基準は参考情報であり、実際には航空会社の規定に準じます。",
	"mall_flight_flightdetails_tuigaiguizeyihangsishenheweizhun":"払い戻し・変更規則は航空会社の審査に準じます。",
	"mall_flight_flightdetails_yudingtuijianhangban": "おすすめの低価格便を予約",
	"mall_flight_flightdetails_jixuyudingyuanhangban": "元のフライトの予約を続ける",
	"mall_flight_flightdetails_gjgsclzctjnyddjhb": "会社の出張規定に基づき、低価格便のご予約をお勧めします。",
	"mall_flight_flightdetails_weibei":"違反",
	"mall_flight_flightdetails_qingyihangsishenheweizhun":"航空会社の審査に準じてください。",
	"mall_flight_flightdetails_gaihangbanweiyinbeiguizebukeyuding":"当該フライトは規則違反のため予約できません。",
	"mall_flight_flightdetails_nsyddxyjgxytqbàcngsy":"ご予約の法人契約運賃は事前登録が必要です。サービスホットライン4000888020までお電話ください。ありがとうございます！",
	"mall_flight_flightdetails_zhe":"{0}割引",//这个折扣也存在问题
	"mall_flight_flightdetails_yihangsizuixinguidingweizhun":"航空会社の最新規定に準ずる",
	"mall_flight_flightdetails_kongke":"エアバス",
	"mall_flight_flightdetails_boyin":"ボーイング",
	"mall_flight_flightlist_zhongzhuan":"乗り継ぎ",
	"mall_flight_flightlist_jinsheng":"残り{0}",
	"mall_flight_flightlist_zhang":"枚",
	"mall_flight_flightlist_chongzu":"十分",
	"mall_flight_flightlist_jingting":"経由",
	"mall_flight_flightlist_weibeiguize":"規則違反",
	"mall_flight_flightlist_fuheguize":"ルールに合致",
	"mall_flight_flightlist_jiazaizhong":"読み込み中...",
	"mall_flight_flightlist_shanghai":"上海",
	"mall_flight_flightlist_beijing":"北京",
	"mall_flight_flightlist_dengdai": "{city} (待機：{time})",
	"mall_flight_flightorder_zhifei":"直行便",
	"mall_flight_flightorder_yueri":"MM月DD日",
	"mall_flight_flightorder_piaojia":"運賃",
	"mall_flight_flightorder_yuan":"¥{0}元",
	"mall_flight_flightorder_jijianranyou":"空港使用料・燃油サーチャージ",
	"mall_flight_flightorder_yuanren":"元/人",
	"mall_flight_flightorder_baoxian":"、保険",
	"mall_flight_flightorder_hangbanxiangqing":"フライト詳細",
	"mall_flight_flightorder_xuanzechuhangren":"搭乗者を選択",
	"mall_flight_flightorder_minhangxianzhixinggonggao": "民間航空旅客のリチウム電池及び危険品機内持ち込み制限に関する公告",
	"mall_flight_flightorder_minhangxianzhixinggonggaoneirong":"民間航空旅客のリチウム電池及び危険品機内持ち込み制限に関する公告\n\t2015年07月06日\n\n\t一. 民間航空旅客の手荷物内のリチウム電池持ち込みに関する公告\n\n\t旅客手荷物内のリチウム電池の航空輸送安全を強化するため、民航局、民航華東地区管理局は相次いで「旅客手荷物内のリチウム電池の安全な航空輸送の強化に関する通知」を発布し、民航各関連部門に対し、旅客手荷物内のリチウム電池の安全輸送管理を一層徹底するよう要求した。旅客手荷物内にリチウム電池を持ち込む場合、国際民間航空機関（ICAO）の「危険物安全航空輸送技術細則」に基づき、以下の規定を実行する：\n\n\t旅客または乗務員が個人使用目的で携行する、リチウムまたはリチウムイオン電池セルもしくは電池を内蔵した携帯型電子機器（リチウム電池モバイルバッテリー、腕時計、電卓、カメラ、携帯電話、ノートパソコン、ポータブルビデオカメラ等）は、機内持ち込み手荷物として携行しなければならない。また、リチウム金属電池のリチウム含有量は2グラムを超えてはならず、リチウムイオン電池の定格エネルギー量は100Wh（ワット時）を超えてはならない。100Whを超え160Wh以下のものは、航空会社の承認を得た上で、機内持ち込み手荷物内の機器に装着した状態でのみ携行できる。160Whを超えるリチウム電池の持ち込みは厳禁する。\n\n\t携帯型電子機器の予備電池は、短絡を防ぐため必ず一個ずつ保護措置を施し（元の小売包装に入れるか、電極を絶縁するなどの方法、例えば露出した電極にテープを貼る、または各電池を別々のビニール袋や保護ケースに入れる）、かつ機内持ち込み手荷物としてのみ携行できる。航空会社の承認を得た100～160Whの予備リチウム電池は、2個までしか携行できない。\n\n\t飛行中、起動スイッチ付きのリチウム電池モバイルバッテリー（充電器）は、スイッチがオフ状態であることを確認しなければならない。モバイルバッテリーを民生用電子機器の充電や外部電源として使用してはならない。モバイルバッテリーのその他の機能を起動してはならない。\n\n\t旅客および乗務員がリチウムイオン電池駆動の車椅子その他類似の移動補助具、および旅客が医療目的で携行するリチウム金属またはリチウムイオン電池セルもしくは電池を内蔵した携帯型医療用電子機器については、「危険物安全航空輸送技術細則」の輸送および包装要件に従って携行し、航空会社の承認を得なければならない。\n\n\t付：リチウム電池安全輸送のご案内\n\n\t一、持ち込み可能なリチウム電池\n\n\t100Wh（ワット時）以下のリチウム電池を内蔵したノートパソコン、携帯電話、カメラ、腕時計等の個人用携帯型電子機器および予備電池は、機内持ち込み手荷物として携行できます。\n\n\t一般的に、携帯電話のリチウム電池の定格エネルギーは3～10Wh程度、一眼レフカメラのリチウム電池は10～20Wh程度、ポータブルビデオカメラのリチウム電池は20～40Wh程度、ノートパソコンのリチウム電池は30～100Wh以上と様々です。したがって、携帯電話、一般的なポータブルビデオカメラ、一眼レフカメラ、そして大多数のノートパソコン等の電子機器内のリチウム電池は、通常100Whの制限を超えることはありません。\n\n\t二、持ち込み制限のあるリチウム電池\n\n\t航空会社の承認を得た場合、100Whを超え160Wh以下のリチウム電池を内蔵した電子機器を機内に持ち込むことができます。このような予備電池を携行できるのは、旅客一人につき2個までで、預け入れ手荷物に入れることはできません。\n\n\t100Whを超えるリチウム電池を含む可能性のある機器としては、報道機関用機材、映像制作チーム用機材、演出用小道具、医療機器、電動玩具、電動工具、工具箱などがあります。\n\n\t三、持ち込み禁止のリチウム電池\n\n\t160Whを超える大型リチウム電池または電子機器の持ち込み、預け入れは禁止されています。\n\n\t四、予備リチウム電池の保護措置\n\n\t予備電池は、短絡を防ぐため必ず一個ずつ保護措置を施してください（元の小売包装に入れるか、電極を絶縁するなどの方法、例えば露出した電極にテープを貼る、または各電池を別々のビニール袋や保護ケースに入れる）。\n\n\t五、リチウム電池の定格エネルギーの判定方法\n\n\tリチウム電池に定格エネルギーWh（ワット時）が直接表示されていない場合、以下の方法で換算できます：\n\n\t1、電池の公称電圧(V)と公称容量(Ah)が分かっている場合、計算によって定格ワット時数値を求めることができます：\n\n\tWh= V x Ah\n\n\t公称電圧と公称容量は通常、電池に表示されています。\n\n\t2、電池にミリアンペア時(mAh)のみが表示されている場合、その数値を1000で割ってアンペア時(Ah)を求めます。\n\n\t例：リチウム電池の公称電圧が3.7V、公称容量が760 mAhの場合、その定格ワット時数は：\n\n\t760 mAh / 1000 = 0.76Ah\n\n\t3.7Vx0.76Ah=2.9Wh\n\n\t民間航空旅客の「モバイルバッテリー」機内持ち込み規定に関する公告\n\n\tモバイルバッテリーとは、主に携帯電話等の電子機器に外部電源を供給するためのリチウム電池モバイル電源を指します。現行の有効な国際民間航空機関（ICAO）「危険物安全航空輸送技術細則」および「中国民用航空危険品輸送管理規定」に基づき、旅客がモバイルバッテリーを機内に持ち込む際は、以下の規定を遵守しなければなりません：\n\n\t一、モバイルバッテリーは、旅客個人が自ら使用するために携行するものでなければなりません。\n\n\t二、モバイルバッテリーは機内持ち込み手荷物または身の回り品としてのみ携行でき、預け入れ手荷物に入れることは厳禁します。\n\n\t三、モバイルバッテリーの定格エネルギーが100Whを超えない場合は、航空会社の承認は不要です。定格エネルギーが100Whを超え160Wh以下の場合は、航空会社の承認を得た場合に限り携行できますが、旅客一人につき2個を超えて携行することはできません。\n\n\t四、定格エネルギーが160Whを超えるモバイルバッテリーの携行は厳禁します。定格エネルギーが表示されておらず、かつ表示されている他のパラメータからも計算により定格エネルギーを算出できないモバイルバッテリーの携行は厳禁します。\n\n\t五、飛行中にモバイルバッテリーを使用して電子機器を充電してはなりません。起動スイッチ付きのモバイルバッテリーの場合、飛行中は常にモバイルバッテリーの電源を切っておかなければなりません。\n\n\t上記規定は乗務員にも同様に適用されます。\n\n\t本公告は公布日より施行します。\n\n\t付：モバイルバッテリーの定格エネルギーの判定方法\n\n\tモバイルバッテリーの定格エネルギーの判定方法\n\n\tモバイルバッテリーに定格エネルギーWh（ワット時）が直接表示されていない場合、以下の方法で換算できます：\n\n\t1、モバイルバッテリーの公称電圧(V)と公称容量(Ah)が分かっている場合、計算によって定格エネルギー数値を求めることができます： Wh= V x Ah 公称電圧と公称容量は通常、モバイルバッテリーに表示されています。\n\n\t2、モバイルバッテリーにミリアンペア時(mAh)のみが表示されている場合、その数値を1000で割ってアンペア時(Ah)を求めます。\n\n\t例：モバイルバッテリーの公称電圧が3.7V、公称容量が760 mAhの場合、その定格エネルギーは：\n\n\t760 mAh ÷ 1000 = 0.76Ah\n\n\t3.7V×0.76Ah=2.9Wh\n\n\t二． 危険品の機内持ち込み禁止\n\n\t潜在的な危険性を持つ関連物品を携行する場合は、航空会社または空港係員にご相談ください。\n\n\t酒類、液体日用品、および個人使用のリチウム電池内蔵携帯機器とその予備リチウム電池等の物品は、民間航空の関連規定に従って携行してください。",
	"mall_flight_flightorder_chongshenchiruchurujingzhengjian": "香港・マカオ居民、華僑の出入国証件使用に関する再確認について",
	"mall_flight_flightorder_chongshenchiruchurujingzhengjianneirong":"尊敬するユーザー各位：\n\n\t当局が相次いで発布した「香港・マカオ・台湾居民居住証使用業務に関する通知」（局方発明電[2018]2343号）、「出入国証件の利便化応用推進工作方案の実施に関する通知」（局方発明電[2019]1461号）に基づき、香港・マカオ・台湾居民、華僑が出入国証件を使用する際に、内地居民と同様の利便性の高いサービスを享受できるよう、ここに関連内容を再確認します：\n\t一、香港・マカオ居民の内地往来通行証、華僑が使用する旅券（以下、出入国証件と略称）は、国内線旅客の有効な搭乗用身分証明書であり、旅客は出入国証件を使用して内地（大陸）路線の航空券予約、チェックイン、保安検査、搭乗手続きを行うことができます。香港・マカオ居民、華僑が国際（地区）路線を利用する場合の証件政策は、引き続き従来の規定に従います。\n\t二、香港・マカオ居民、華僑が出入国証件を使用して内地（大陸）路線を利用する場合、所持者は航空券予約、チェックイン、保安検査、搭乗時に同一の証件を使用しなければなりません。\n\t三、香港・マカオ居民、華僑が使用する出入国証件を紛失した場合、民用空港公安局に「民用航空便搭乗用臨時身分証明書」を申請することができます。 ここに通知します。",
	"mall_flight_flightorder_qingheduidingdanxinxi": "注文情報をご確認ください",
	"mall_flight_flightorder_shoujihaoma": "携帯電話番号",
	"mall_flight_flightorder_querenwuwuxiayibu": "確認しました、次へ",
	"mall_hotel_hotel_ruzhushijian":"チェックイン時間",
	"mall_hotel_hotel_gong":"合計",
	"mall_hotel_hotel_wan":"泊",
	"mall_hotel_hotel_lidianshijian":"チェックアウト時間",
	"mall_hotel_hotel_guanjianziweizhipinpaijiudianming":"キーワード/場所/ブランド/ホテル名",
	"mall_hotel_hotel_qingshuruguanjianziweizhipinpaijiudianming":"キーワード/場所/ブランド/ホテル名",
	"mall_hotel_hotel_tianjialvke":"搭乗者を追加",
	"mall_hotel_hotel_dianjixuanzelvke":"クリックして搭乗者を選択",
	"mall_hotel_hotel_sousuo":"検索",
	"mall_hotel_hotel_dfjqbycgjrzrqbycgwrx":"ご予約は5部屋以内、宿泊日数は20泊以内でお願いします。特別なご予約が必要な場合は、弊社カスタマーサービスまでご連絡ください。",
	"mall_hotel_hotel_shanghai":"上海",
	"mall_hotel_hotel_yueri":"MM月DD日",
	"mall_hotel_hotel_qingxuanzelvke":"搭乗者を選択してください",
	"mall_hotel_hotel_lvkeshuliangshangxianqinglianxikefu":"宿泊人数の上限です。カスタマーサービスまでご連絡ください。",
	"mall_hotel_hotel_wenxintishi":"ご注意",
	"mall_hotel_hotel_zxydcgwfyknbzjylxkfh":"オンライン予約が20泊を超える場合、客室が不足する可能性があります。より多くの客室オプションについては、カスタマーサービスへのお問い合わせをお勧めします。",
	"mall_hotel_hotel_jixuyuding":"予約を続ける",
	"mall_hotel_hotel_lianxikefu":"カスタマーサービスに連絡",
	"mall_hotel_hotel_xiangqing": "詳細",
	"mall_hotel_hoteldetails_fanhui":"戻る",
	"mall_hotel_hoteldetails_pingfen":"評価",
	"mall_hotel_hoteldetails_fen":"点",
	"mall_hotel_hoteldetails_zanwupingfen":"評価なし",
	"mall_hotel_hoteldetails_xingji":"{0}つ星",
	"mall_hotel_hoteldetails_tingchechang":"駐車場",
	"mall_hotel_hoteldetails_jianshenfang":"ジム",
	"mall_hotel_hoteldetails_hanglijicun":"手荷物預かり",
	"mall_hotel_hoteldetails_dizhi":"住所:{0}",
	"mall_hotel_hoteldetails_dianhua":"電話:{0}",
	"mall_hotel_hoteldetails_yueri":"M月DD日",
	"mall_hotel_hoteldetails_ruzhu":"チェックイン",
	"mall_hotel_hoteldetails_lidian":"チェックアウト",
	"mall_hotel_hoteldetails_wan":"泊",
	"mall_hotel_hoteldetails_jianren":"1部屋{0}名",
	"mall_hotel_hoteldetails_qi":"￥{0}から",
	"mall_hotel_hoteldetails_zao":"朝食",
	"mall_hotel_hoteldetails_kezhu":"宿泊可能",
	"mall_hotel_hoteldetails_ren":"名",
	"mall_hotel_hoteldetails_bukequxiao":"キャンセル不可",
	"mall_hotel_hoteldetails_fuheguize":"ルールに合致",
	"mall_hotel_hoteldetails_weibeiguize":"規則違反",
	"mall_hotel_hoteldetails_yuding":"予約",
	"mall_hotel_hoteldetails_gaijiudianzanwuheshifangjian":"このホテルには適切な部屋がありません！",
	"mall_hotel_hoteldetails_xieyijiudian":"契約ホテル",
	"mall_hotel_hoteldetails_wu":"なし",
	"mall_hotel_hoteldetails_dan":"シングル",
	"mall_hotel_hoteldetails_shuang":"ダブル",
	"mall_hotel_hoteldetails_duo":"複数",
	"mall_hotel_hoteldetails_weibei":"違反",
	"mall_hotel_hoteldetails_gaifangjianyinweibeiguizebukeyuding":"この部屋は規則違反のため予約できません",
	"mall_hotel_hoteldetails_wenxintishi":"ご注意",
	"mall_hotel_hoteldetails_bjdwxyjdknczfxqnzxbh":"当ホテルは契約ホテルであり、リスクが伴う可能性があります。ご了承の上、ご旅行の手配をお願いいたします。",
	"mall_hotel_hotellist_meiyougengduoliao":"これ以上ありません",
	"mall_hotel_hotellist_qi":"￥{0}から",
	"mall_hotel_hotellist_fen":"点",
	"mall_hotel_hotellist_weibeiguize":"規則違反",
	"mall_hotel_hotellist_fuheguize":"ルールに合致",
	"mall_hotel_hotellist_xianshiquanbu": "すべて表示",
	"mall_hotel_hotellist_jiazaizhong":"読み込み中...",
	"mall_hotel_hotellist_xieyijiudian":"契約ホテル",
	"mall_hotel_hotelorder_ruzhu":"チェックイン:",
	"mall_hotel_hotelorder_wan":"泊",
	"mall_hotel_hotelorder_lidian":"チェックアウト:",
	"mall_hotel_hotelorder_jian":"/部屋",
	"mall_hotel_hotelorder_dingdanquerenhoubukequxiao":"注文確認後はキャンセル不可",
	"mall_hotel_hotelorder_tuigaixiangqing":"キャンセル・変更詳細",
	"mall_hotel_hotelorder_ruzhuxinxi":"宿泊情報",
	"mall_hotel_hotelorder_dingdantianxie":"注文情報入力",
	"mall_hotel_hotelorder_yueri":"M月DD日",
	"mall_flight_hotelorder_qingheduidingdanxinxi": "注文情報をご確認ください",
	"mall_flight_hotelorder_querenwuwuxiayibu": "確認しました、次へ",
	"mall_modules_addpassengers_fanhui":"戻る",
	"mall_modules_addpassengers_tianjiachengke":"乗客を追加",
	"mall_modules_addpassengers_wancheng":"完了",
	"mall_modules_addpassengers_qingshurulvkemingchengpipeihuotianjiaweilinke":"旅客名を入力して検索するか、臨時旅客として追加してください",
	"mall_modules_addpassengers_tianjia":"+ 追加",
	"mall_modules_addpassengers_wei":"に",
	"mall_modules_addpassengers_linke":"臨時旅客",
	"mall_modules_addpassengers_shanchu":"削除",
	"mall_modules_addpassengers_qingjianglinkemingchengshurudaosousuokuangneihouzhongshi":"臨時旅客名を検索ボックスに入力してから再試行してください",
	"mall_modules_change_gaiqian":"変更",
	"mall_modules_change_gaiqianyuanyin":"変更理由",
	"mall_modules_change_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"変更・キャンセル規定及び手数料基準は、実際には航空会社の定めによります",
	"mall_modules_change_xiayibuqingxuanzegaiqianriqi":"次へ、変更日を選択してください",
	"mall_modules_change_tuigaiguize":"変更・キャンセル規定",
	"mall_modules_change_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したい、もう飛びたくない",
	"mall_modules_change_jicuohangchengriqishijianxingming":"旅程、日付、時間、氏名を間違えた",
	"mall_modules_change_hangbanyanwuhuoquxiao":"フライトの遅延または欠航",
	"mall_modules_change_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"貴社の出張規定に基づき、変更理由をお選びください",
	"mall_modules_change_qingxuanzexuyaogaiqiandelvcheng":"変更する旅程を選択してください",
	"mall_modules_change_qingxuanzelvke":"搭乗者を選択してください",
	"mall_modules_change_shanghai":"上海",
	"mall_modules_change_beijing":"北京",
	"mall_modules_change_gaichecimeiyoupipeituigaiguize":"この列車には該当する変更・キャンセルルールがありません",
	"mall_modules_choosecontraryreason_weibeiyuanyin":"違反理由",
	"mall_modules_choosecontraryreason_qingshuruliyoumingcheng":"理由名を入力してください",
	"mall_modules_choosecostcenter_chengbenzhongxin":"コストセンター",
	"mall_modules_choosecostcenter_feiyongfudanbumen": "費用負担部門",
	"mall_modules_chooseprojectcode_qingshuruxiangmudaima":"プロジェクトコードを入力してください",
	"mall_modules_chooseprojectcode_tianjia":"追加",
	"mall_modules_chooseprojectcode_weixiangmudaima":"プロジェクトコード",
	"mall_modules_choosetripintent_chalvmude":"出張目的",
	"mall_modules_choosetripintent_qingshuruchalvmude":"出張目的を入力してください",
	"mall_modules_editrole_fanhui":"戻る",
	"mall_modules_editrole_tianjialinke":"臨時列車を追加",
	"mall_modules_editrole_xingpinyin":"姓（ピンイン）",
	"mall_modules_editrole_mingpinyin":"名（ピンイン）",
	"mall_modules_editrole_zhongwenxingming":"中国語氏名",
	"mall_modules_editrole_qingshuruxingming":"氏名を入力してください",
	"mall_modules_editrole_zhengjianleixing":"証明書の種類",
	"mall_modules_editrole_dianjixuanzezhengjianleixing":"クリックして証明書の種類を選択",
	"mall_modules_editrole_xingbie":"性別",
	"mall_modules_editrole_dianjixuanzexingbie":"クリックして性別を選択",
	"mall_modules_editrole_guoji":"国籍",
	"mall_modules_editrole_dianjixuanzeguoji":"クリックして国籍を選択",
	"mall_modules_editrole_zhengjianhaoma":"身分証明書番号",
	"mall_modules_editrole_qingshuruzhengjianhaoma":"身分証明書番号を入力してください",
	"mall_modules_editrole_chushengriqi":"生年月日",
	"mall_modules_editrole_dianjixuanzechushengriqi":"クリックして生年月日を選択",
	"mall_modules_editrole_shoujihaoma":"携帯電話番号",
	"mall_modules_editrole_qingshurushoujihaoma":"携帯電話番号を入力してください",
	"mall_modules_editrole_youxiang": "メールアドレス",
	"mall_modules_editrole_qingtianxieyouxianghaoma": "メールアドレスを入力してください",
	"mall_modules_editrole_sfbcwck": "常連客として保存しますか？",
	"mall_modules_editrole_baocun":"保存",
	"mall_modules_editrole_lichenggongsi":"力程公司",
	"mall_modules_editrole_nan":"男性",
	"mall_modules_editrole_nv":"女性",
	"mall_modules_editrole_zhongguo":"中国",
	"mall_modules_editrole_sclzcgkxzyjylkxxxggn": "出張ポリシーの管理制限により、搭乗者情報の変更機能は無効になっています。",
	"mall_modules_frequentercardfill_fanhui":"戻る",
	"mall_modules_frequentercardfill_tianxiechangkelvkeqia":"マイレージ会員カードを入力",
	"mall_modules_frequentercardfill_zhangsan":"張三",
	"mall_modules_frequentercardfill_qingxuanzehangkonggongsi":"航空会社を選択してください",
	"mall_modules_frequentercardfill_qingtianxiechanglvkeqiahao":"マイレージ会員番号を入力してください",
	"mall_modules_frequentercardfill_wancheng":"完了",
	"mall_modules_frequentercardfill_dongfanghangkong":"中国東方航空",
	"mall_modules_frequentercardfill_zhongguohangkong":"中国航空",
	"mall_modules_frequentercardfill_nanfanghangkong":"南方航空",
	"mall_modules_productdetails_fanhui":"戻る",
	"mall_modules_producthome_chalvguizemingcheng":"出張規則名：",
	"mall_modules_producthome_guoji": "国際",
	"mall_modules_producthome_guonei": "国内",
	"mall_modules_producthome_jipiaofuwu": "航空券サービス",
	"mall_modules_producthome_jiudianfuwu": "ホテルサービス",
	"mall_modules_producthome_huochefuwu": "鉄道サービス",
	"mall_modules_producthome_zuidijiagejizhun":"最低価格基準：",
	"mall_modules_producthome_shishihangbanguankong":"リアルタイムフライト管理：",
	"mall_modules_producthome_tiqianyudingshijian":"事前予約時間：",
	"mall_modules_producthome_cangweijibiexianzhi":"クラス制限：",
	"mall_modules_producthome_zuoweijibiexianzhi":"座席クラス制限：",
	"mall_modules_producthome_xieyijipiaoyouxian":"契約航空券優先：",
	"mall_modules_producthome_xieyijiudianyouxian":"契約ホテル優先：",
	"mall_modules_producthome_xiaofeijineshangxian":"利用金額上限：",
	"mall_modules_producthome_dangdizhusubiaozhun": "現地宿泊費基準：",
	"mall_modules_producthome_shenpimingcheng":"承認名：",
	"mall_modules_producthome_toudengcang":"ファーストクラス",
	"mall_modules_producthome_shangwucang":"ビジネスクラス",
	"mall_modules_producthome_jingjicang":"エコノミークラス",
	"mall_modules_producthome_jingjicang5zhe":"エコノミークラス(50%割引)",
	"mall_modules_producthome_jingjicang6zhe":"エコノミークラス(60%割引)",
	"mall_modules_producthome_jingjicang7zhe":"エコノミークラス(30%割引)",
	"mall_modules_producthome_jingjicang8zhe":"エコノミークラス(20%割引)",
	"mall_modules_producthome_jingjicang9zhe":"エコノミークラス(10%割引)",
	"mall_modules_producthome_yinei":"以内",
	"mall_modules_producthome_bufenhangxian":"一部路線",
	"mall_modules_producthome_bufenjiudian":"一部ホテル",
	"mall_modules_producthome_jichengshiyinei":"{0}級都市{1}-{2}以内",
	"mall_modules_productlist_fanhui":"戻る",
	"mall_modules_productlist_tuigaiguize":"変更・キャンセル規定",
	"mall_modules_productlist_zhu":"チェックイン",
	"mall_modules_productlist_li":"チェックアウト",
	"mall_modules_productlist_guanjianziweizhijiudianmingpinpai":"キーワード/位置/ホテル名/ブランド",
	"mall_modules_productlist_qianyitian":"前日",
	"mall_modules_productlist_houyitian":"翌日",
	"mall_modules_productlist_weizhijuli":"位置距離",
	"mall_modules_productlist_jiagexingji":"価格/星ランク",
	"mall_modules_productlist_shaixuan":"絞り込み",
	"mall_modules_productlist_queren":"確認",
	"mall_modules_productlist_gengduoshaixuan":"さらに絞り込む",
	"mall_modules_productlist_chalvguizemingcheng":"出張規則名：",
	"mall_modules_productlist_zuidijiagejizhun":"最低価格基準：",
	"mall_modules_productlist_shishihangbanguankong":"リアルタイムフライト管理：",
	"mall_modules_productlist_tiqianyudingshijian":"事前予約時間：",
	"mall_modules_productlist_cangweijibiexianzhi":"クラス制限：",
	"mall_modules_productlist_zuoweijibiexianzhi":"座席クラス制限：",
	"mall_modules_productlist_xieyijipiaoyouxian":"契約航空券優先：",
	"mall_modules_productlist_xieyijiudianyouxian":"契約ホテル優先：",
	"mall_modules_productlist_xiaofeijineshangxian":"利用金額上限：",
	"mall_modules_productlist_dangdizhusubiaozhun": "現地宿泊費基準：",
	"mall_modules_productlist_shenpimingcheng":"承認名：",
	"mall_modules_productlist_toudengcang":"ファーストクラス",
	"mall_modules_productlist_shangwucang":"ビジネスクラス",
	"mall_modules_productlist_jingjicang":"エコノミークラス",
	"mall_modules_productlist_jingjicangzhe":"エコノミークラス(50%割引)",
	"mall_modules_productlist_hangzhengqu":"行政区",
	"mall_modules_productlist_buxian":"制限なし",
	"mall_modules_productlist_shangyequ":"商業区",
	"mall_modules_productlist_jiage":"価格",
	"mall_modules_productlist_yixia":"¥ 150以下",
	"mall_modules_productlist_yishang":"¥ 600以上",
	"mall_modules_productlist_xingji":"星ランク",
	"mall_modules_productlist_erxingjijiyixia":"二つ星以下",
	"mall_modules_productlist_sanxingjishushi":"三つ星/コンフォート",
	"mall_modules_productlist_sixingjigaodang":"四つ星/高級",
	"mall_modules_productlist_wuxingjihaohua":"五つ星/ラグジュアリー",
	"mall_modules_productlist_tese":"特色",
	"mall_modules_productlist_fuwu":"サービス",
	"mall_modules_productlist_xieyijiudian": "契約ホテル",
	"mall_modules_productlist_Huazhu": "華住酒店",
	"mall_modules_productlist_chexingxuanze":"車種選択",
	"mall_modules_productlist_gaotie":"高速鉄道(G/C)",
	"mall_modules_productlist_dongche":"動車(D)",
	"mall_modules_productlist_putong":"普通列車(Z/T/K)",
	"mall_modules_productlist_qitadeng":"その他(L/Y等)",
	"mall_modules_productlist_qita":"その他",
	"mall_modules_productlist_facheshijian":"出発時間",
	"mall_modules_productlist_chalvzhengce":"出張規定",
	"mall_modules_productlist_fuheguize":"ルールに合致",
	"mall_modules_productlist_weibeiguize":"規則違反",
	"mall_modules_productlist_chufachezhan":"出発駅",
	"mall_modules_productlist_daodachezhan":"到着駅",
	"mall_modules_productlist_zhinengpaixu":"スマート並べ替え",
	"mall_modules_productlist_morenpaixu":"デフォルト並べ替え",
	"mall_modules_productlist_dijiayouxian":"低価格優先",
	"mall_modules_productlist_gaojiayouxian":"高価格優先",
	"mall_modules_productlist_xingjiyouxian":"星評価優先",
	"mall_modules_productlist_putongyouxian":"普通優先",
	"mall_modules_productlist_shijianpaixu":"時間順",
	"mall_modules_productlist_congzaodaowan":"朝から晩まで",
	"mall_modules_productlist_congwandaozao":"晩から朝まで",
	"mall_modules_productlist_jiagepaixu":"価格順",
	"mall_modules_productlist_congdidaogao":"低い順",
	"mall_modules_productlist_conggaodaodi":"高い順",
	"mall_modules_productlist_qifeishijian":"出発時間",
	"mall_modules_productlist_qifeijichang":"出発空港",
	"mall_modules_productlist_daodajichang":"到着空港",
	"mall_modules_productlist_cangwei":"クラス",
	"mall_modules_productlist_hangkonggongsi":"航空会社",
	"mall_modules_productlist_yinei":"以内",
	"mall_modules_productlist_bufenhangxian":"一部路線",
	"mall_modules_productlist_bufenjiudian":"一部ホテル",
	"mall_modules_productlist_jichengshiyinei":"{0}級都市{1}以内",
	"mall_modules_addkeywords_guanjianziweizhijiudianmingpinpai": "キーワード/位置/ホテル名/ブランド",
	"mall_modules_addkeywords_qsrhxggjzwzppjdmckssjg": "キーワード/場所/ブランド/ホテル名を入力または修正して検索結果を表示",
	"mall_modules_refund_tuidingyuanyin":"キャンセル理由",
	"mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun":"変更・キャンセル規定及び手数料基準は、実際には航空会社の定めによります",
	"mall_modules_refund_zongji":"合計：",
	"mall_modules_refund_yujituipiaofei": "キャンセル料見込み：",
	"mall_modules_refund_mingxi":"明細",
	"mall_modules_refund_tijiaoshenhe":"審査に提出",
	"mall_modules_refund_hangchengbiangeng":"旅程変更",
	"mall_modules_refund_hangchengquxiao":"旅程キャンセル",
	"mall_modules_refund_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したい、もう飛びたくない",
	"mall_modules_refund_jicuohangchengriqishijianxingming":"旅程、日付、時間、氏名を間違えた",
	"mall_modules_refund_hangbanyanwuhuoquxiao":"フライトの遅延または欠航",
	"mall_modules_refund_genjuguisidechalvbiaozhunqingxuanzetuidingyuanyin":"貴社の出張規定に基づき、キャンセル理由を選択してください",
	"mall_modules_refund_shenqingtuipiao":"払い戻し申請",
	"mall_modules_refund_shenqingtuifang":"チェックアウト申請",
	"mall_modules_refund_qingxuanzexuyaotuidingdelvcheng":"キャンセルする旅程を選択してください",
	"mall_modules_refund_qingxuanzelvke":"搭乗者を選択してください",
	"mall_modules_refund_qingxuanzetuidingyuanyin":"キャンセル理由を選択してください",
	"mall_modules_refund_tuipiaoshenqingtijiaochenggong":"払い戻し申請が正常に送信されました",
	"mall_modules_remarks_xuqiubeizhu":"要望備考",
	"mall_modules_remarks_baocun":"保存",
	"mall_modules_remarks_ndtsxqwmhjlxtrwfmzwm":"お客様の特別なご要望については、可能な限り調整いたします。ご要望に添えない場合でも、別途ご連絡はいたしませんので、あらかじめご了承ください",
	"mall_modules_productlist_zhongzhuanzhifei": "直行便/乗継便",
	"mall_modules_productlist_jinkanzhongzhuan": "乗継便のみ表示",
	"mall_modules_productlist_jinkanzhifei": "直行便のみ表示",
	"mall_order_shifa":"出発地",
	"mall_order_jingting": "経由",
	"mall_order_yueri":"MM月DD日 ddd",
	"mall_order_tuigaixuzhi": "変更・払い戻しについて",
	"mall_order_fangjianshu":"部屋数",
	"mall_order_jian":"間",
	"mall_order_rfjcgwjsklxkfhcfyd": "部屋数が5部屋を超える場合は、カスタマーサービスにお問い合わせいただくか、予約を分割してください！",
	"mall_order_meijianzuiduokezhu":"1部屋あたりの最大宿泊人数",
	"mall_order_ren":"名",
	"mall_order_zuoxixuanze": "座席選択",
	"mall_order_chuang": "窓側",
	"mall_order_guodao": "通路側",
	"mall_order_wbzndslcxqwbbztxxycysczjyz":"お客様のスムーズなご旅行のため、ご入力いただく情報は旅行時に携帯する身分証明書と必ず一致させてください",
	"mall_order_fasongduanxin":"SMSを送信",
	"mall_order_baoxianxinxi":"保険情報",
	"mall_order_yqqjjqfhslrsbxdzfwyf":"感染症流行期間中の感染対策強化、ビジネス旅行者向け保険カスタマイズサービス。一つの保障で、家族みんなが安心",

	"mall_order_shanglvxinxi":"ビジネス旅行情報",
	"mall_order_shenpipingzheng": "承認証憑",
	"mall_order_youshenpipingzheng": "承認証憑あり",
	"mall_order_wushenpipingzheng": "承認証憑なし",
	"mall_order_shenpizhuangtai": "承認ステータス",
	"mall_order_chuchaishenqingiworkyishenpi": "出張申請Iworker承認済み",
	"mall_order_shangweishenpi": "未承認",
	"mall_order_yijishenpi": "レベル承認",


	"mall_order_shenpidanhao":"承認番号",
	"mall_order_liuchenglingdaochuchabaogaodanhao":"IMISフローリーダー出張報告番号",
	"mall_order_chengbenzhongxin":"コストセンター",
	"mall_order_feiyongfudanbumen":"費用負担部門",
	"mall_order_qingxuanzechengbenzhongxin":"コストセンターを選択してください",
	"mall_order_qingxuanzefeiyongfudanbumen":"費用負担部門を選択してください",
	"mall_order_chalvmude":"出張目的",
	"mall_order_qingxuanzechalvmude":"出張目的を選択してください",
	"mall_order_mudexiangqing":"目的詳細",
	"mall_order_chalvmudebumingquexubuchongxiangxichalvmude":"出張事由",
	"mall_order_xiangmudaima":"プロジェクトコード",
	"mall_order_qingxuanzexiangmudaima":"プロジェクトコードを選択してください",
	"mall_order_weibeiyuanyin":"違反理由",
	"mall_order_yusuanbianma": "予算コード",
	"mall_order_fujianxinxi": "添付情報",
	"mall_order_yusuanmiaoshu": "予算説明",
	"mall_order_xingchengweibeile": "旅程が違反しました",
	'mall_order_dezhengce': "のポリシー",
	"mall_order_qingxuanzeweibeiyuanyin":"違反理由を選択してください",
	"mall_order_xiangxiyuanyin":"詳細理由",
	"mall_order_lianxirenxinxi":"連絡先情報",
	"mall_order_xingming":"氏名",
	"mall_order_qingshuruyonghuming":"ユーザー名を入力してください",
	"mall_order_shouji":"携帯電話",
	"mall_order_qingshurushoujihao":"携帯電話番号を入力してください",
	"mall_order_youxiang":"メールアドレス",
	"mall_order_qingshuruyouxiang":"メールアドレスを入力してください",
	"mall_order_xuqiubeizhu":"要望備考",
	"mall_order_koukuanshuoming":"差引説明:",
	"mall_order_hgjndfkfsjhysqhkcffr":"お客様のお支払い方法に応じて事前承認または宿泊費の引き落としが行われます。ご注文が確定されない場合、事前承認は解除されるか、全額がお客様のお支払い口座に返金されます。このご注文は確定後のキャンセル・変更はできません。ご宿泊がない場合は初日の宿泊費を申し受けます。また、早期チェックアウトの場合は、早期チェックアウト当日分の料金を差し引かせていただきます。",
	"mall_order_tebietishi":"特別注意事項:",
	"mall_order_gjddrzsjwtfbzjssjwrt":"このホテルのチェックイン時間は14:00、チェックアウトの標準清算時間は12:00です。早期チェックインまたはチェックアウトの延長は、いずれも状況に応じて追加料金が発生します。",
	"mall_order_mingxi":"明細",
	"mall_order_tijiaozhifu":"提出/支払い",
	"mall_order_feiyongmingxi":"料金明細",
	"mall_order_baoxianfei":"保険料",
	"mall_order_fuwufei":"サービス料",
	"mall_order_zonge":"総額",
	"mall_order_dingdanzhengzaishengcheng":"注文を生成中...",
	"mall_order_nulizhanzuozhong":"座席確保に奮闘中...",
	"mall_order_tuipiaoshuoming":"払い戻し説明",
	"mall_order_dgcgwqpqfcqsjdyfzkjr":"1、購入代行が成功し、未発券かつ発車時刻まで35分以上ある場合、「マイオーダー」から鉄道注文をクリックし、案内に従って払い戻しを申請できます。発車8日前以降の払い戻しについては、鉄道局が切符1枚ごとに段階的に払い戻し手数料を徴収します。",
	"mall_order_dgcgyqphfcqsjxyfzxnz":"2、購入代行が成功したが、既に発券済みか発車時刻まで35分未満の場合、お客様ご自身で、切符購入時に使用した乗車人の有効な身分証明書原本と鉄道切符をお持ちになり、発車前に駅の払い戻し窓口で払い戻し手続きを行う必要があります。",
	"mall_order_gaiqianshuoming":"変更説明",
	"mall_order_wqzzpqlfcsjdyfzkgqdy":"1、紙の切符を未発券で、かつ発車時刻まで35分以上ある場合、元の切符運賃と同額かそれ以下の列車に変更できます。その他、オンラインで変更できない場合は、発車前に駅窓口で手続きが必要です。",
	"mall_order_kcqxsyskgqysqndcckcq":"2、発車48時間前以上であれば、予約販売期間内の列車に変更できます。発車48時間前未満の場合は、切符面の日付当日24:00までの任意の列車に変更可能で、切符面の日付翌日以降への変更はできません。",
	"mall_order_xcppjdyycpdthcédcébf":"3、新しい切符の運賃が元の切符より安い場合、差額を返金します。差額部分については払い戻し手数料が発生し、現行の払い戻し手数料基準が適用されます。",
	"mall_order_querendingdan":"注文確認",
	"mall_order_xuanzechuhangren":"搭乗者を選択",
	"mall_order_lichenggongsi":"力程公司",
	"mall_order_yi":"一",
	"mall_order_er":"二",
	"mall_order_san":"三",
	"mall_order_yueri1":"MM月DD日",
	"mall_order_qingtianxiexiangmudaima":"プロジェクトコードを入力してください",
	"mall_order_qingtianxieshenpidanhao":"承認番号を入力してください",
	"mall_order_qingtianxiechalvmude":"出張目的を入力してください",
	"mall_order_qingtianxiexiangqingmude":"詳細目的を入力してください",
	"mall_order_qingtianxieweibeixiangqingyuanyin":"違反詳細理由を入力してください",
	"mall_order_ghbjpwzhxscpnxxzyzbx":"このフライトの航空券はセット販売商品です。保険商品を1つ選択する必要があります。または、他のフライトの航空券をお選びください。",
	"mall_order_gcczxwzhxscpnxxzyzbx":"この列車の座席はセット販売商品です。保険商品を1つ選択する必要があります。または、他の列車をお選びください。",
	"mall_order_qingtianxielvkezhengjianhaoma":"旅客の身分証明書番号を入力してください",
	"mall_order_wenxintishi":"ご注意！",
	"mall_order_shifoujixuyuding":"{0}は予約を続けますか",
	"mall_order_ddcjcghynsszddxxzgzd":"注文が正常に作成されました。注文詳細でいつでも注文の進捗状況を確認できます",
	"mall_order_hejiazhong":"価格確認中...",
	"mall_order_fangjianshubukedayuruzhurenshu":"部屋数は宿泊人数を超えることはできません",
	"mall_train_train_chufadi":"出発地",
	"mall_train_train_mudedi":"目的地",
	"mall_train_train_chufashijian":"出発時間",
	"mall_train_train_zuoxi":"座席",
	"mall_train_train_yidengzuo":"一等席",
	"mall_train_train_tianjialvke":"搭乗者を追加",
	"mall_train_train_dianjixuanzelvke":"クリックして搭乗者を選択",
	"mall_train_train_sousuo":"検索",
	"mall_train_train_dangqianshiduanbutigongchecichaxunfuwu":"現在の時間帯では列車番号の照会サービスを提供していません",
	"mall_train_train_tsgpsjwzwgpgqhtpxbwy":"ご注意：チケット購入時間は朝5:30～深夜00:30です。購入、変更、払い戻しは発車30分前までに行ってください。当日の行程は10分以内に、24時間以降の行程は25分以内にお支払いください。",
	"mall_train_train_shanghai":"上海",
	"mall_train_train_beijing":"北京",
	"mall_train_train_yueri":"MM月DD日",
	"mall_train_train_qingxuanzelvke":"搭乗者を選択してください",
	"mall_train_trainchangeinfos_gaiqian":"変更",
	"mall_train_trainchangeinfos_yuanchecixinxi":"元の列車情報",
	"mall_train_trainchangeinfos_di":"第{0}",
	"mall_train_trainchangeinfos_cheng":"区間",
	"mall_train_trainchangeinfos_yueri":"MM月DD日",
	"mall_train_trainchangeinfos_tuigaiguize":"変更・キャンセル規定",
	"mall_train_trainchangeinfos_xinchecixinxi":"新しい列車情報",
	"mall_train_trainchangeinfos_chuhangrenxinxi":"搭乗者情報",
	"mall_train_trainchangeinfos_shouji":"携帯電話：163******42",
	"mall_train_trainchangeinfos_shenfenzheng":"身分証明書：3424********0981",
	"mall_train_trainchangeinfos_tuigaiqianguizejifeiyongbiaozhunshijixuyishijishenheweizhun":"変更・キャンセル規定及び料金基準は、実際の審査に基づきます",
	"mall_train_trainchangeinfos_zongji":"合計：",
	"mall_train_trainchangeinfos_mingxi":"明細",
	"mall_train_trainchangeinfos_tijiaoshenhe":"審査に提出",
	"mall_train_trainchangeinfos_woyaogaibianhangchengbuxiangfeiliao":"旅程を変更したい、もう飛びたくない",
	"mall_train_trainchangeinfos_jicuohangchengriqishijianxingming":"旅程、日付、時間、氏名を間違えた",
	"mall_train_trainchangeinfos_hangbanyanwuhuoquxiao":"フライトの遅延または欠航",
	"mall_train_trainchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin":"貴社の出張規定に基づき、変更理由をお選びください",
	"mall_train_trainchangeinfos_gaiqianchenggongqingninguanzhudingdanzhuangtai":"変更が成功しました。注文ステータスにご注意ください！",
	"mall_train_trainchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie":"現在のご注文は変更できません。お電話にてカスタマーサービスまでお問い合わせください。ありがとうございます！",
	"mall_train_traindetails_checixiangqing":"列車詳細",
	"mall_train_traindetails_tuigaiguize":"変更・キャンセル規定",
	"mall_train_traindetails_shifa":"出発地",
	"mall_train_traindetails_weibeiguize":"規則違反",
	"mall_train_traindetails_fuheguize":"ルールに合致",
	"mall_train_traindetails_youpiao":"チケットあり",
	"mall_train_traindetails_wupiao":"チケットなし",
	"mall_train_traindetails_jinsheng":"残りわずか",
	"mall_train_traindetails_zhang":"枚",
	"mall_train_traindetails_ding":"予約",
	"mall_train_traindetails_tuipiaoshuoming":"払い戻し説明",
	"mall_train_traindetails_dgcgwqpqfcqsjdyfzkjr":"1、購入代行が成功し、未発券かつ発車時刻まで35分以上ある場合、「マイオーダー」から鉄道注文をクリックし、案内に従って払い戻しを申請できます。発車8日前以降の払い戻しについては、鉄道局が切符1枚ごとに段階的に払い戻し手数料を徴収します。",
	"mall_train_traindetails_dgcgyqphfcqsjxyfzxnz":"2、購入代行が成功したが、既に発券済みか発車時刻まで35分未満の場合、お客様ご自身で、切符購入時に使用した乗車人の有効な身分証明書原本と鉄道切符をお持ちになり、発車前に駅の払い戻し窓口で払い戻し手続きを行う必要があります。",
	"mall_train_traindetails_gaiqianshuoming":"変更説明",
	"mall_train_traindetails_wqzzpqlfcsjdyfzkgqdy":"1、紙の切符を未発券で、かつ発車時刻まで35分以上ある場合、元の切符運賃と同額かそれ以下の列車に変更できます。その他、オンラインで変更できない場合は、発車前に駅窓口で手続きが必要です。",
	"mall_train_traindetails_kcqxsyskgqysqndcckcq":"2、発車48時間前以上であれば、予約販売期間内の列車に変更できます。発車48時間前未満の場合は、切符面の日付当日24:00までの任意の列車に変更可能で、切符面の日付翌日以降への変更はできません。",
	"mall_train_traindetails_xcppjdyycpdthcédcébf":"3、新しい切符の運賃が元の切符より安い場合、差額を返金します。差額部分については払い戻し手数料が発生し、現行の払い戻し手数料基準が適用されます。",
	"mall_train_traindetails_weibei":"違反",
	"mall_train_trainlist_weibeiguize":"規則違反",
	"mall_train_trainlist_fuheguize":"ルールに合致",
	"mall_train_trainlist_shouqi":"閉じる",
	"mall_train_trainlist_zhankai":"展開する",
	"mall_train_trainlist_you":"あり",
	"mall_train_trainlist_zhang":"枚",
	"mall_train_trainlist_wu":"なし",
	"mall_train_trainlist_zhanxu":"駅順",
	"mall_train_trainlist_zhanming":"駅名",
	"mall_train_trainlist_daoshi":"到着時刻",
	"mall_train_trainlist_fashi":"出発時刻",
	"mall_train_trainlist_tingliu":"停車時間",
	"mall_train_trainlist_jiazaizhong":"読み込み中...",
	"mall_train_trainlist_xiuxizhongmingtianzailai":"休憩中、明日また...",
	"mall_train_trainlist_dqcczxwypqnlxqtcchlā":"現在の列車の座席に空きはありません！他の列車をお選びいただき、計画的にご旅行ください。ありがとうございます！",
	"mall_train_trainlist_qita":"その他",
	"mall_train_trainorder_zhifei":"直行便",
	"mall_train_trainorder_yueri":"MM月DD日",
	"mall_train_trainorder_piaojia":"運賃",
	"mall_train_trainorder_yuan":"元(",
	"mall_train_trainorder_jijianranyou":"空港建設費・燃油サーチャージ{{ totalPrices(",
	"mall_train_trainorder_yuanrenbaoxianyuanren":"元/人、保険20元/人",
	"mall_train_trainorder_checixiangqing":"列車詳細",
	"modules_selectcity_qingshuruchengshimingcheng":"都市名を入力してください",
	"modules_selectcity_guoji": "国際",
	"modules_selectcity_guonei": "国内",
	"modules_selectcity_diqu":"地域",
	"modules_selectcity_chezhan":"駅",
	"modules_selectcity_remen":"人気",
	"modules_webmap_dingwei":"位置情報",
	"modules_webmap_wodebeizhu":"自分のメモ",
	"modules_webmap_wodebiaoji":"自分のマーク",
	"order_flight_flightdetail_di":"第",
	"order_flight_flightdetail_cheng":"区間",
	"order_flight_flightdetail_yueri":"MM月DD日",
	"order_flight_flightdetail_tuigaiguize":"変更・キャンセル規定",
	"order_flight_flightorderinfo_dancheng":"(片道)",
	"order_flight_flightorderinfo_weibeiguize":"規則違反",
	"order_flight_flightorderinfo_gongxiang":"共有",
	"order_flight_flightorderinfo_nianyueri":"YYYY年M月DD日 ddd",
	"order_flight_flightorderinfo_tuigaiguize":"変更・キャンセル規定",
	"order_flight_flightorderinfo_yiquxiao":"キャンセル済み",
	"order_flight_flightorderinfo_weibeizhengceyuanyin":"違反理由：{0}",
	"order_flight_flightorderinfo_weibeixiangqing": "違反詳細：",
	"order_flight_flightorderinfo_quchuli":"処理へ",
	"order_flight_flightorderinfo_details":"詳細",
	"order_flight_flightorderinfo_fuhezhengcedingdanshenpi":"ポリシー準拠注文承認",
	"order_flight_flightorderinfo_mingxi": "明細",
	"order_flight_flightorderinfo_gaiqian":"変更",
	"order_flight_flightorderinfo_tuipiao":"払い戻し",
	"order_flight_flightorderinfo_quxiaotuipiao":"払い戻しキャンセル",
	"order_flight_flightorderinfo_quxiaogaiqian":"変更キャンセル",
	"order_flight_flightorderinfo_quxiaodingdan":"注文キャンセル",
	"order_flight_flightorderinfo_shenpi":"承認",
	"order_flight_flightorderinfo_shenqingren":"申請者：{0}",
	"order_flight_flightorderinfo_gaiqianren":"変更者：{0}",
	"order_flight_flightorderinfo_gaiqianyuanyin":"変更理由：{0}",
	"order_flight_flightorderinfo_xiangqingyuanyin":"詳細理由：{0}",
	"order_flight_flightorderinfo_jiazaizhong":"読み込み中...",
	"order_flight_flightorderinfo_yunxutuipiao":"払い戻し許可",
	"order_flight_flightorderinfo_jujuetuipiao":"払い戻し拒否",
	"order_flight_flightorderinfo_yunxugaiqian":"変更許可",
	"order_flight_flightorderinfo_jujuegaiqian":"変更拒否",
	"order_flight_flightorderinfo_shenpitongguo":"承認通過",
	"order_flight_flightorderinfo_shenpijujue":"承認拒否",
	"order_flight_flightorderinfo_xiaoshizhi": "時間まで",
	"order_flight_flightorderinfo_tianqian": "日前",
	"order_flight_flightorderinfo_tianzhi": "日まで",
	"order_flight_flightorderinfo_gaiqianshouqu": "変更手数料",
	"order_flight_flightorderinfo_tuipiaoshouqu": "払い戻し手数料",
	"order_flight_flightorderinfo_deshouxufei": "の手数料",
	"order_flight_flightorderinfo_xiaoshiqian": "時間前",
	"order_flight_flightorderinfo_xiaoshizhiqian": "時間前",
	"order_flight_flightorderinfo_xiaoshizhihou": "時間後",
	"order_flight_flightorderinfo_tianzhiqian": "日前",
	"order_flight_flightorderinfo_qifeiqian": "出発前",
	"order_flight_flightorderinfo_qifeihou": "出発後",
	"order_flight_flightorderinfo_xiaoshi": "時間",
	"order_flight_flightorderinfo_tian": "日",
	"order_hotel_hoteldetail_wan":"泊",
	"order_hotel_hoteldetail_tuigaixiangqing":"キャンセル・変更詳細",
	"order_hotel_hoteldetail_ri":"日",
	"order_hotel_hoteldetail_yi":"一",
	"order_hotel_hoteldetail_er":"二",
	"order_hotel_hoteldetail_san":"三",
	"order_hotel_hoteldetail_si":"四",
	"order_hotel_hoteldetail_wu":"五",
	"order_hotel_hoteldetail_liu":"六",
	"order_hotel_hoteldetail_zhou":"週",
	"order_hotel_hoteldetail_wuzao":"朝食なし",
	"order_hotel_hotelorderinfo_yueri":"MM月DD日",
	"order_hotel_hotelorderinfo_jian": "間",
	"order_hotel_hotelorderinfo_wan":"泊",
	"order_hotel_hotelorderinfo_weibeiguize":"規則違反",
	"order_hotel_hotelorderinfo_jiudianxiangqing":"ホテル詳細",
	"order_hotel_hotelorderinfo_tuigaiguize":"変更・キャンセル規定",
	"order_hotel_hotelorderinfo_yiquxiao":"キャンセル済み",
	"order_hotel_hotelorderinfo_wozhidaoliao":"わかりました",
	"order_hotel_hotelorderinfo_weibeizhengceyuanyin":"ポリシー違反の理由：{0}",
	"order_hotel_hotelorderinfo_quchuli":"処理へ",
	"order_hotel_hotelorderinfo_fuhezhengcedingdanshenpi":"ポリシー準拠注文承認",
	"order_hotel_hotelorderinfo_mingxi": "明細",
	"order_hotel_hotelorderinfo_shenqingtuifang":"チェックアウト申請",
	"order_hotel_hotelorderinfo_quxiaotuifang":"チェックアウトをキャンセル",
	"order_hotel_hotelorderinfo_quxiaodingdan":"注文キャンセル",
	"order_hotel_hotelorderinfo_shenpi":"承認",
	"order_hotel_hotelorderinfo_shenqingren":"申請者：{0}",
	"order_hotel_hotelorderinfo_gaiqianren":"変更者：{0}",
	"order_hotel_hotelorderinfo_gaiqianyuanyin":"変更理由：{0}",
	"order_hotel_hotelorderinfo_wuzao":"朝食なし",
	"order_orderInfo_yunxutuipiao": "払い戻し許可",
	"order_orderInfo_jujuetuipiao": "払い戻し拒否",
	"order_orderInfo_yunxugaiqian": "変更許可",
	"order_orderInfo_jujuegaiqian": "変更拒否",
	"order_orderInfo_shenpitongguo": "承認通過",
	"order_orderInfo_shenpijujue": "承認拒否",
	"order_orderInfo_tuipiaoren": "払い戻し申請者",
	"order_orderInfo_tuipiaoyuanyin": "払い戻し理由",
	"order_orderInfo_gaiqianren": "変更者",
	"order_orderInfo_gaiqianyuanyin": "変更理由",
	"order_orderInfo_chuxingren": "旅行者",
	"order_orderInfo_chuxingmudi": "旅行目的",
	"order_orderdetails_dingdanxiangqing":"注文詳細",
	"order_orderdetails_dingdanhao":"注文番号:{0}",
	"order_orderdetails_ruzhurenxinxi":"宿泊者情報",
	"order_orderdetails_chuhangrenxinxi":"搭乗者情報",
	"order_orderdetails_shouji":"携帯電話",
	"order_orderdetails_shenfenzheng": "身分証明書",
	"order_orderdetails_shanglvxinxi":"ビジネス旅行情報",
	"order_orderdetails_chengbenzhongxin":"コストセンター",
	"order_orderdetails_feiyongfudanbumen": "費用負担部門",
	"order_orderdetails_chalvmudi":"出張目的",
	"order_orderdetails_chuchaishiyou": "出張事由",
	"order_orderdetails_xiangmudaima":"プロジェクトコード",
	"order_orderdetails_lianxiren":"連絡先",
	"order_orderdetails_xingming":"氏名",
	"order_orderdetails_youxiang":"メールアドレス",
	"order_orderdetails_xuqiubeizhu":"要望備考",
	"order_orderdetails_fujianxinxi": "添付情報",
	"order_orderdetails_fujianmingcheng": "添付ファイル名",
	"order_orderdetails_caozuo":"操作",
	"order_orderdetails_w": "なし",
	"order_orderdetails_koukuanshuoming":"差引説明:",
	"order_orderdetails_hgjndfkfsjhysqhkcffr":"お客様のお支払い方法に応じて事前承認または宿泊費の引き落としが行われます。ご注文が確定されない場合、事前承認は解除されるか、全額がお客様のお支払い口座に返金されます。このご注文は確定後のキャンセル・変更はできません。ご宿泊がない場合は初日の宿泊費を申し受けます。また、早期チェックアウトの場合は、早期チェックアウト当日分の料金を差し引かせていただきます。",
	"order_orderdetails_tebietishi":"特別注意事項:",
	"order_orderdetails_gjddrzsjwtfbzjssjwrt":"このホテルのチェックイン時間は14:00、チェックアウトの標準清算時間は12:00です。早期チェックインまたはチェックアウトの延長は、いずれも状況に応じて追加料金が発生します。",
	"order_orderdetails_zongji":"合計:",
	"order_orderdetails_mingxi":"明細",
	"order_orderdetails_feiyongmingxi":"料金明細",
	"order_orderdetails_baoxianfei":"保険料",
	"order_orderdetails_fuwufei":"サービス料",
	"order_orderdetails_zonge":"総額",
	"order_orderdetails_tuigaiguize":"変更・キャンセル規定",
	"order_orderdetails_ri":"日",
	"order_orderdetails_yi":"一",
	"order_orderdetails_er":"二",
	"order_orderdetails_san":"三",
	"order_orderdetails_si":"四",
	"order_orderdetails_liu":"六",
	"order_orderdetails_zhou":")} (${week}曜日)",
	'order_orderdetails_daiqueren':"確認待ち",
	'order_orderdetails_yituihui':"返却済み",
	'order_orderdetails_yiwancheng':"完了",
	'order_orderdetails_daichuli':"処理待ち",
	"order_orderdetails_quanbutuipiao":"全員払い戻し",
	"order_orderdetails_quanbutuipiaozhong":"全員払い戻し中",
	"order_orderdetails_quanbugaiqian":"全員変更",
	"order_orderdetails_quanbugaiqianzhong":"全員変更中",
	"order_orderlist_wodedingdan":"マイオーダー",
	"order_orderlist_meiyougengduoliao":"これ以上ありません",
	"order_orderlist_yudingshijian":"予約時間：",
	"order_orderlist_weibeiguize":"規則違反",
	"order_orderlist_fuheguize":"ルールに合致",
	"order_orderlist_chufa":"出発",
	"order_orderlist_zhi":"まで",
	"order_orderlist_wei":"に",
	"order_orderlist_yuding":"予約",
	"order_orderlist_yueri":"MM DD",
	"order_orderlist_jipiao":"航空券",
	"order_orderlist_jiudian":"ホテル",
	"order_orderlist_huoche":"電車",
	"order_orderlist_zuche":"レンタカー",
	"order_train_traindetail_di":"第{0}",
	"order_train_traindetail_cheng":"区間",
	"order_train_traindetail_yueri":"MM月DD日",
	"order_train_traindetail_tuigaiguize":"変更・キャンセル規定",
	"order_train_trainorderinfo_dancheng":"(片道)",
	"order_train_trainorderinfo_weibeiguize":"規則違反",
	"order_train_trainorderinfo_gongxiang":"共有",
	"order_train_trainorderinfo_jianpiaokou":"改札口",
	"order_train_trainorderinfo_zhida":"直行",
	"order_train_trainorderinfo_zongyongshi":"総所要時間：{0}",
	"order_train_trainorderinfo_nianyueri":"YYYY年M月DD日 ddd",
	"order_train_trainorderinfo_tuigaiguize":"変更・キャンセル規定",
	"order_train_trainorderinfo_yiquxiao":"キャンセル済み",
	"order_train_trainorderinfo_tuipiaoshuoming":"払い戻し説明",
	"order_train_trainorderinfo_dgcgwqpqfcqsjdyfzkjr":"1、購入代行が成功し、未発券かつ発車時刻まで35分以上ある場合、「マイオーダー」から鉄道注文をクリックし、案内に従って払い戻しを申請できます。発車8日前以降の払い戻しについては、鉄道局が切符1枚ごとに段階的に払い戻し手数料を徴収します。",
	"order_train_trainorderinfo_dgcgyqphfcqsjxyfzxnz":"2、購入代行が成功したが、既に発券済みか発車時刻まで35分未満の場合、お客様ご自身で、切符購入時に使用した乗車人の有効な身分証明書原本と鉄道切符をお持ちになり、発車前に駅の払い戻し窓口で払い戻し手続きを行う必要があります。",
	"order_train_trainorderinfo_gaiqianshuoming":"変更説明",
	"order_train_trainorderinfo_wqzzpqlfcsjdyfzkgqdy":"1、紙の切符を未発券で、かつ発車時刻まで35分以上ある場合、元の切符運賃と同額かそれ以下の列車に変更できます。その他、オンラインで変更できない場合は、発車前に駅窓口で手続きが必要です。",
	"order_train_trainorderinfo_kcqxsyskgqysqndcckcq":"2、発車48時間前以上であれば、予約販売期間内の列車に変更できます。発車48時間前未満の場合は、切符面の日付当日24:00までの任意の列車に変更可能で、切符面の日付翌日以降への変更はできません。",
	"order_train_trainorderinfo_xcppjdyycpdthcédcébf":"3、新しい切符の運賃が元の切符より安い場合、差額を返金します。差額部分については払い戻し手数料が発生し、現行の払い戻し手数料基準が適用されます。",
	"order_train_trainorderinfo_wozhidaoliao":"わかりました",
	"order_train_trainorderinfo_mingxi": "明細",
	"order_train_trainorderinfo_weibeizhengceyuanyin":"ポリシー違反の理由：{0}",
	"order_train_trainorderinfo_quchuli":"処理へ",
	"order_train_trainorderinfo_fuhezhengcedingdanshenpi":"ポリシー準拠注文承認",
	"order_train_trainorderinfo_gaiqian":"変更",
	"order_train_trainorderinfo_tuipiao":"払い戻し",
	"order_train_trainorderinfo_quxiaotuipiao":"払い戻しキャンセル",
	"order_train_trainorderinfo_quxiaogaiqian":"変更キャンセル",
	"order_train_trainorderinfo_quxiaodingdan":"注文キャンセル",
	"order_train_trainorderinfo_shenpi":"承認",
	"order_train_trainorderinfo_shenqingren":"申請者：{0}",
	"order_train_trainorderinfo_gaiqianren":"変更者：{0}",
	"order_train_trainorderinfo_gaiqianyuanyin":"変更理由：{0}",
	"order_train_trainorderinfo_xiangqingyuanyin":"詳細理由：{0}",
	"system_newaddress_shezhimorendizhi":"デフォルト住所を設定",
	"system_newaddress_shanchu":"削除",
	"system_about_about_lichengshanglv":"力程商旅",
	"system_approvalset_provisionalauthorization_linshishenpishouquan":"臨時承認権限",
	"system_approvalset_provisionalauthorization_qingxuanze":"選択してください",
	"system_approvalset_provisionalauthorization_shouquanyuangong":"権限付与従業員",
	"system_approvalset_provisionalauthorization_kaishiriqi":"開始日",
	"system_approvalset_provisionalauthorization_xuanzeshijian":"時間を選択",
	"system_approvalset_provisionalauthorization_jiezhishijian":"締切時間：",
	"system_approvalset_provisionalauthorization_shouquanshichang":"権限付与期間",
	"system_approvalset_provisionalauthorization_xiaoshi":"時間",
	"system_approvalset_provisionalauthorization_tian":"日",
	"system_approvalset_provisionalauthorization_shi":"時",
	"system_approvalset_list_baocun":"保存",
	"system_approvalset_list_shouquanliebiao":"権限付与リスト",
	"system_approvalset_list_yijianqingchu":"一括クリア",
	"system_approvalset_list_yiguoqi":"期限切れ",
	"system_approvalset_list_shouquanzhong":"権限付与中",
	"system_approvalset_list_quxiaoxiugai":"変更をキャンセル",
	"system_approvalset_list_qingxuanzeshouquanyuangong":"認証担当者を選択してください",
	"system_autoupdate_autoupdate_faxianxinbanben":"新しいバージョンが見つかりました",
	"system_autoupdate_autoupdate_xinzeng":"{0}.新規追加{1}",
	"system_autoupdate_autoupdate_lijigengxin":"今すぐ更新",
	"system_configinfo_configinfo_baocun":"保存",
	"system_configinfo_configinfo_peizhiguanli":"構成管理",
	"system_configinfo_configinfo_youxiang":"メールアドレス",
	"system_configinfo_configinfo_weixin":"微信",
	"system_configinfo_configinfo_daishenpi":"承認待ち",
	"system_configinfo_configinfo_daiqueren":"確認待ち",
	"system_configinfo_configinfo_daizhifu":"支払い待ち",
	"system_configinfo_configinfo_daichuli":"処理待ち",
	"system_configinfo_configinfo_yiwancheng":"完了",
	"system_configinfo_configinfo_baocunchenggong":"保存に成功しました",
	"system_download_download_banbenhao":"バージョン番号：V1.16",
	"system_download_download_daxiao":"サイズ：8.75MB",
	"system_download_download_jieshao":"紹介",
	"system_download_download_yingyongjieshao":"アプリ紹介",
	"system_download_download_slcglqxdqyslglxtykqd":"APPは力程国旅傘下の企業出張管理システムであり、強力なリソース、先進的な技術、質の高いサービス、専門的な管理に依存して、多くの企業のビジネス出張、予約、承認フローを最適化します。",
	"system_download_download_yonghukeyitongguo":"ユーザーは以下を通じて",
	"system_download_download_xtksdjhjpjdhcpdcxyds":"APPシステムで航空券、ホテル、鉄道チケットの検索、予約、承認などのサービスを迅速に行うことができ、出張管理をスマート化し、ユーザーが出張時に借金、立替、精算を不要にし、ユーザーの出張満足度を向上させます。企業の消費コスト削減、財務精算プロセスの簡素化、運営効率の向上を真に実現します。",
	"system_download_download_zhuyaogongneng":"主な機能",
	"system_download_download_àcsrqqfsjdxxcxbydjpj":"1、都市、日付、出発時間などの情報に基づいて航空券、ホテル、鉄道チケットを検索・予約します；",
	"system_download_download_qyyjdpwxygdkjkdphsxy":"2、企業の月末決済チケット予約（従業員の立替不要でチケット予約可能）と与信従業員管理；",
	"system_download_download_qingsongchakanguanlidingdanyijiantuipiaogaiqian":"3、注文の確認・管理が簡単で、ワンクリックで払い戻し・変更が可能；",
	"system_download_download_zcqydcbgkszydgczlhgk":"4、企業の出張規定管理設定をサポートし、予約プロセス中に柔軟に管理します。企業が出張ポリシーをより適切に実行し、コストを節約するのに役立ちます。",
	"system_feedback_feedback_fankuileixing":"フィードバックの種類",
	"system_feedback_feedback_fankuineirong":"フィードバック内容",
	"system_feedback_feedback_wltgwmdfwhzlwmwntgfw":"サービスと品質を向上させるため、お客様からの苦情やご提案を受け付ける専用チャネルをご用意しております。ご意見はすぐにトップに届けられます！",
	"system_feedback_feedback_shangchuanzhaopian":"写真をアップロード",
	"system_feedback_feedback_shangchuantupianshuomingkeyigengfangbianwomenlijienindexuqiuo":"写真をアップロードしていただくと、お客様のご要望をより理解しやすくなります",
	"system_feedback_feedback_yibianwomengeininhuifu":"ご返信のために",
	"system_feedback_feedback_shoujihao":"携帯電話番号:",
	"system_feedback_feedback_qitalianxifangshiyouxiang":"その他の連絡先（メール/QQ...）",
	"system_feedback_feedback_qita":"その他",
	"system_feedback_feedback_tijiao":"送信",
	"system_feedback_feedback_yijianfankui":"ご意見・ご要望",
	"system_feedback_feedback_shijuetiyan":"ビジュアル体験",
	"system_feedback_feedback_caozuotiyan":"操作体験",
	"system_feedback_feedback_zhengzaishangchuan":"アップロード中",
	"system_feedback_feedback_shangchuanchenggong":"アップロード成功",
	"system_feedback_feedback_shangchuanshibai":"アップロード失敗",
	"system_feedback_feedback_qingtianxienindebaoguiyijianhuoshangchuanzhaopian":"貴重なご意見をご記入いただくか、写真をアップロードしてください",
	"system_feedback_feedback_tijiaochenggongganxienindefankui":"送信が完了しました。ご意見ありがとうございます",
	"system_mall_addinvoice_shanchu":"削除",
	"system_mall_addtraveller_shanchu":"削除",
	"system_mall_modules_travelername_xingmingxuyuxiedaichuhangdezhengjianyizhifouzehuiyingxianghangcheng":"お名前は旅行時に携帯する身分証明書と一致している必要があります。一致しない場合、旅行に影響が出る可能性があります",
	"system_mall_modules_travelername_tianxiexuzhi":"記入上の注意",
	"system_mall_modules_travelername_yitianxieshuoming":"一. 記入説明",
	"system_mall_modules_travelername_chengkexingmingxuyudengjisuochizhengjianshangdemingziyizhi":"1. 搭乗者名は搭乗時に提示する身分証明書の名前と一致する必要があります。",
	"system_mall_modules_travelername_wqbslchqqblhjsrqzsbz":"2. スムーズなご旅行のため、旅行終了日が身分証明書の有効期限より少なくとも6ヶ月以上先であることを確認し、正確で有効な身分証明書番号を入力してください。ご注文送信後の変更はできません。",
	"system_mall_modules_travelername_erxinbanhuzhao":"二. 新パスポート",
	"system_mall_modules_travelername_sanjiubanhuzhao":"三. 旧パスポート",
	"system_mall_modules_travelername_sigangaotonghangzheng":"四. 香港・マカオ通行許可証",
	"system_mall_modules_travelername_wutaiwantonghangzheng":"五. 台湾通行許可証",
	"system_mall_modules_travelername_liutaibaozheng":"六. 台湾同胞旅行証明書",
	"system_mall_oftenpassenger_gongsichangke":"企業マイレージ会員",
	"system_mall_oftenpassenger_gerenchangke":"個人マイレージ会員",
	"system_messagenotify_messagenotify_gong":"合計",
	"system_messagenotify_messagenotify_tiaoxiaoxi":"件のメッセージ",
	"system_messagenotify_messagenotify_weiduxiaoxi":"未読メッセージ",
	"system_messagenotify_messagenotify_yiduxiaoxi":"既読メッセージ",
	"system_messagenotify_messagenotify_zanwuxiaoxi":"メッセージはありません",
	"system_messagenotify_messagenotify_xiaoxitongzhi":"メッセージ通知",
	"system_messagenotify_messagenotify_quanbuxiaoxi":"すべてのメッセージ",
	"system_messagenotify_messagenotify_xitongtongzhi":"システム通知",
	"system_messagenotify_messagenotify_xiaoxitixing":"メッセージリマインダー",
	"system_messagenotify_notifyitem_xitongtongzhi":"システム通知",
	"system_messagenotify_notifyitem_xiaoxitixing":"メッセージリマインダー",
	"system_messagenotify_notifyitem_ganggang":"たった今",
	"system_messagenotify_notifyitem_shanchu":"削除",
	"system_modules_calendar_zhongzhi":"リセット",
	"system_modules_calendar_ri":"日",
	"system_modules_calendar_yi":"一",
	"system_modules_calendar_er":"二",
	"system_modules_calendar_san":"三",
	"system_modules_calendar_si":"四",
	"system_modules_calendar_wu":"五",
	"system_modules_calendar_liu":"六",
	"system_modules_calendar_yuandan":"元旦",
	"system_modules_calendar_qingmingjie":"清明節",
	"system_modules_calendar_laodongjie":"労働節",
	"system_modules_calendar_guoqingjie":"国慶節",
	"system_modules_calendar_chuxi":"大晦日",
	"system_modules_calendar_chunjie":"春節",
	"system_modules_calendar_duanwujie":"端午節",
	"system_modules_calendar_zhongqiujie":"中秋節",
	"system_user_account_account_jiebang":"バインド解除",
	"system_user_businessregister_qiyeyonghuzhuce":"企業ユーザー登録",
	"system_user_businessregister_ruguigongsiyishilichengshanglvqianyueqiye":"もし貴社がすでに力程商旅の契約企業であるならば、",
	"system_user_businessregister_qinglianxinindechalvfuzerenhuoquzhanghaowuzhongfuzhuce": "貴社の出張責任者に連絡してアカウントを取得し、重複登録しないでください",
	"system_user_businessregister_qingshuruninqiyemingcheng":"貴社の企業名を入力してください",
	"system_user_businessregister_qiyemingcheng":"企業名",
	"system_user_businessregister_shoujihaohuoyouxiangzhuce":"携帯電話番号またはメールアドレスで登録",
	"system_user_businessregister_shoujihao":"携帯電話番号",
	"system_user_businessregister_qingshuruyanzhengma":"認証コードを入力してください",
	"system_user_businessregister_yanzhengma":"認証コード",
	"system_user_businessregister_qingshuruguiqiyesuoshuhangye":"貴社の業界を入力してください",
	"system_user_businessregister_qiyehangye":"企業業界",
	"system_user_businessregister_qingshuruguiqiyediqu":"貴社の地域を入力してください",
	"system_user_businessregister_qiyediqu":"企業地域",
	"system_user_businessregister_qingtianxielianxirenxingming":"連絡先の氏名を入力してください",
	"system_user_businessregister_lianxiren":"連絡先",
	"system_user_businessregister_zhucezhanghao":"アカウント登録",
	"system_user_businessregister_qingshezhidenglumima":"ログインパスワードを設定してください",
	"system_user_businessregister_denglumima":"ログインパスワード",
	"system_user_businessregister_zaicishurumima":"パスワードを再入力",
	"system_user_businessregister_querenmima":"パスワード確認",
	"system_user_businessregister_tongyi":"同意する",
	"system_user_businessregister_fuwuxieyi":"サービス利用規約",
	"system_user_businessregister_xiayibuyanzheng":"次へ、認証",
	"system_user_businessregister_wancheng":"完了",
	"system_user_businessregister_ruzhucechuxianwenti":"登録に問題が発生した場合",
	"system_user_businessregister_qingboda": "お電話ください",
	"system_user_businessregister_lianxikefuweinijieda":"カスタマーサービスに連絡して解決します",
	"system_user_businessregister_zhuce":"登録",
	"system_user_businessregister_gongsimingchengbunengkong":"会社名は必須です",
	"system_user_businessregister_dangqianshoujihaoyibeizhuce":"この電話番号は既に登録されています",
	"system_user_main_peizhiguanli":"構成管理",
	"system_user_modules_authorizat_qiyezhanghaoyouxiangshoujihao":"企業アカウント/メールアドレス/電話番号",
	"system_user_modules_authorizat_qingshuruzhanghu":"アカウントを入力してください",
	"system_user_modules_authorizat_buqufendaxiaoxie":"大文字と小文字を区別しません",
	"system_user_modules_authorizat_qingshuruyanzhengma":"認証コードを入力してください",
	"system_user_modules_authorizat_lijibangding":"今すぐバインド",
	"system_user_modules_authorizat_lijizhuce":"企業登録",
	"system_user_modules_authorizat_zhanghaobangding":"アカウントバインド",
	"system_user_modules_authorizat_shoujiyanzhengbangding":"携帯電話認証バインディング",
	"system_user_modules_ordinary_lijizhuce":"今すぐ登録",
	"system_user_modules_ordinary_denglu":"ログイン",
	"system_user_modules_ordinary_xiugaichushimima":"初期パスワードの変更",
	"system_user_modules_password_shezhimima":"パスワード設定",
	"system_user_modules_password_xiacidenglutixingwo":"次回ログイン時に通知する",
	"system_user_modules_yinsishezhi": "プライバシー設定",
	"system_user_modules_gexinghuatuijian": "パーソナライズドレコメンデーション",
	"system_user_modules_gexinghuaguanbi": "オフにするとパーソナライズされたコンテンツのレコメンデーションを受け取れなくなります。お客様のニーズに合ったパーソナライズドコンテンツをお届けするため、オンにすることをお勧めします。",
	"user_resetpwd_mobilevalidate_yanzhengguize":"検証ルール",
	"user_resetpwd_verifyidentity_zhaohuimima":"パスワードを忘れた場合",
	"user_resetpwd_verifyidentity_dengluming":"ログイン名",
	"user_resetpwd_verifyidentity_zhucehuobangdingdeshoujihaohuoyouxiang":"登録またはバインドされた携帯電話番号またはメールアドレス",
	"user_resetpwd_verifyidentity_haiwaishoujiqinganguojiadaimashoujihaomadegeshishururu":"海外の携帯電話は「国コード-携帯電話番号」の形式で入力してください。例：79-66666666",
  "user_resetpwd_verifyidentity_xiayibu":"次へ",
  user:{
    companyName:"力程商旅"
  },
  router:{
    home:"ホーム",
    trip:'旅程',
    my:"マイページ",
  },
  bill:{
    myOrder:"マイオーダー"
  },
  mall: {
    OnBusiness:"業務用",
    OnPersonal:"私用",
    btriprule:"出張規定",
    demandorder:"リクエストシート",
    allprice:"正価",
    discount:"割引",
    GivenName:"英語名",
    Surname:"英語姓",
    selectedseat:"座席選択済み",
    noselectseat:"座席未選択",
    takeOff:"出発",
    FillInfo:"記入上の注意",
    ExpiryDate:'有効期限',
    StartTime:'開始時間',
    EndTime:'終了時間',
    ToProcessDate:"往路日付",
    backTracking:"復路日付",
    sharing:"共有",
    AirplaneModelTxt:"機種",
    ticketfeeFloat:"この価格には空港建設費・燃油サーチャージは含まれていません",
    peopleTypeExplain:"子供・幼児の予約説明",
    bookingTicketExplain:"お子様/幼児の航空券を予約する場合は、当社のカスタマーサービスまでご連絡ください。",
    onlySeeDirect:"直行便のみ表示",
    hiddenSharedFlight:"コードシェア便を非表示",
    ActualCarrier:"実際の運送",
    stayTxt:"停車時間",
    turnTxt:'乗り継ぎ',
    priceRemarks:"以下の料金はすべて「大人1名または子供1名または幼児1名」の一人当たり平均価格です",
    AgreementPrice:"ビジネスおすすめ",
    tax:"税",
    trainHolderKeyWords:"国内鉄道チケット",
    bookingRemarks:"一度に予約できるのは最大5名までです",
    beginTxt:"始",
    passTxt:"過",
    endTxt:"終",
    StandingOrder:"駅順",
    stationName:'駅名',
    arrivalTimeTxt:"到着時刻",
    departTimeTxt:"出発時刻",
    departDate:'出発日',
    arrivalDate:'到着日',
    hotelHolderKeyWords:"キーワード/ホテル名などを入力してください",
    HotelRemarks:"ご予約は5部屋以内、宿泊日数は20泊以内でお願いします。特別なご予約が必要な場合は、弊社カスタマーサービスまでご連絡ください。",
    TrainRemarks:"ご注意：チケット購入時間は朝7:30～夜22:30です。購入、変更、払い戻しは発車30分前までに行ってください。当日の旅程は10分以内に、24時間以降の旅程は25分以内にお支払いください。",
    NoTrainSearch:"現在の時間帯では列車番号の照会サービスを提供していません",
    mapTxt:"地図/ナビ",
    detailsOrFacilities:'詳細/施設',
    noSooner:'朝食なし',
    breakfast:'朝食',
    breakfastTxt:'朝食付き',
    noCancellation:'キャンセル不可',
	timeToCancel:"期間限定キャンセル",
	withWindow:"窓あり",
    RoomsTxt:'部屋数',
    hotelUnit:'泊',
    checkInTxt:'チェックイン',
    checkOutTxt:'チェックアウト',
    checkInDate:'チェックイン日',
    checkOutDate:'チェックアウト日',
    Frequenter:'常連客',
    Temporary:"臨時旅客",
    TemporaryInformation:"臨時旅客情報",
    addFrequenter:'常連客を追加',
    addTemporary:"臨時列車を追加",
    TravelStandard:"出張規定",
    hightToLow:"高い順",
    lowToHight:"低い順",
    morningToNight:"朝から晩まで",
    nightToMorning:"晩から朝まで",
    starLevelTxt:"星ランク",
    filtrateTxt:'絞り込み',
    timeTxt:'時間',
    fromTo:'から',
    contactNumber:"電話番号",
    conformToRules:"ルールに合致",
    breakToRules:"規則違反",
    unlimited:"制限なし",
    beforeDay:'前日',
    afterDay:'翌日',
    adequateTxt:"十分",
    Remaining:"残りわずか",
    taxesTxt:"税金",
    BackTorule:"変更・キャンセル規定",
    trainamendrule:"出発8日前（含まず）以降の払い戻しについては、払い戻し手数料はかかりません。乗車駅の出発時刻の48時間前までの払い戻しは、運賃の5%の手数料がかかります。出発24時間前から48時間前までの払い戻しは、運賃の10%の手数料がかかります。出発24時間前を切った払い戻しは、運賃の20%の手数料がかかります。",
    booking:"予約",
    onlinePay:"オンライン決済",
    departTxt:'出発',
    arrivalTxt:'到着',
    sheet:'枚',
    NoTicket:'チケットなし',
    orderFilltitle:"注文情報入力",
    tripInfosTitle:"搭乗者情報",
    BookingInformation:"予約注意事項",
    tripInfosRemarks:"お客様のスムーズなご旅行のため、ご入力いただく情報は旅行時に携帯する身分証明書と必ず一致させてください",
    addTraveller:"搭乗者を追加",
    UserName:'氏名',
    contactInfosTitle:"連絡先情報",
    RemarkInfosTitle:"備考情報",
    contacts:"連絡先",
    Phone:'携帯電話',
    Email:"メールアドレス",
    InstructTitle:"引き落とし説明",
    InstructContent:"お客様のお支払い方法に応じて、事前承認または宿泊料金の引き落としが行われます。ご注文が確定されない場合、事前承認は解除されるか、全額がお客様のお支払い口座に返金されます。本注文は確定後のキャンセル・変更はできません。ご宿泊がない場合、初日の宿泊料金を申し受けます。また、早期チェックアウトの場合、早期チェックアウト当日分の料金を差し引かせていただきます。",
    SpecialTipsTitle:"特別提示",
    SpecialTipsContent:"このホテルのチェックイン時間は14:00、チェックアウトの標準清算時間は12:00です。早期チェックインまたはチェックアウトの延長は、いずれも状況に応じて追加料金が発生します。",
    travelInformationTitle:"出張情報",
    CostCenter:'コストセンター',
    TravelPurpose:"出張目的",
    ProjectCode:'プロジェクトコード',
    contraryReason:"違反理由",
    ViolateTravelRules:"出張規定違反",
    SpecialRequirement:"特別なご要望",
    SpecialRequirementTips:"特別なご要望備考",
    specialRequirementContent:"お客様の特別なご要望については、可能な限り調整いたします。ご要望に添えない場合でも、別途ご連絡はいたしませんので、あらかじめご了承ください。",
    otherRequirement:"その他のご要望",
    consentAgreement:"送信をクリックすると、以下を読み、同意したものとみなされます",
    importantTerms:"予約注意事項と重要条項",
    BookingHint:"グリーン環境保護を支援するため、デフォルトは電子契約となります。紙の契約書の締結が必要な場合は、カスタマーサービスまでお電話ください。",
    CostDetails:"料金明細",
    payTotalPrice:"お支払い総額",
    totalPrice:'総額',
    roomUnit:'部屋',
    nightUnit:"夜",
    peopleUnit:"名",
    details:"明細",
    CustomerService:"カスタマーサービスに連絡",
    SubmissionOrPayment:"提出/支払い",
    frequentlnformationTitle:"旅客情報",
    TravellerTitle:"旅客氏名",
    EnglishName:"英文氏名",
    LastName:"英語姓",
    firstName:"英語名",
    NameOrIdCardTips:"スムーズなご旅行のため、渡航書類と同じ氏名をご入力ください。",
    CertificateInformatTitle:"書類情報",
    ExpireDate:"書類の有効期限",
    otherInfosTitle:"その他情報",
    Sex:'性別',
    Birthday:'生年月日',
    Nationality:'国籍',
    optionalCard:"旅客カード（任意）",
    reminderInfos:"スムーズなご旅行のため、旅行終了日が書類の有効期限より6ヶ月以上先であることをご確認の上、正確で有効な書類番号をご入力ください。ご注文送信後の変更はできません。",
    addOrEditTraveller:"旅客を追加・編集",
    AllOrder:"すべて",
    orderStatus:"注文状況",
    departTime:'出発時間',
    orderDetail:'注文詳細',
    CancelOrder:"注文キャンセル",
    CancelRefund:"払い戻しキャンセル",
    CancelChange:"変更キャンセル",
    ApprovalRefused:"承認拒否",
    ApproveSucc:"承認通過",
    PayNow:"今すぐ支払う",
    Refund:'払い戻し',
    RefundHotel:'チェックアウト',
    RefundGroup:"ツアーキャンセル",
    Change:'変更',
    SubmitOrder:'注文を送信',
    PriceDetail:"料金詳細",
    CheckOrderProgress:"注文の進捗を確認",
    flightInformation:'フライト情報',
    orderNumber:'注文番号',
    BookingTime:'予約時間',
    First:'第',
    Journey:"区間",
    few:"間",
    Level:'級',
    BackToChangeTips:"最終金額は審査により確定します。ご不明な点がございましたら、カスタマーサービスまでお電話ください。",
    pleaseChoose:"選択してください",
    ThePassengers:"の旅客",
    Transfer:'経由',
    Flight:'フライト',
    RefundRoomsDate:"チェックアウト/チェックイン時間",
    TheReason:"の原因",
    TheTrain:"の列車番号",
    hour:'時間',
    minute:'分',
    Gym:'ジム',
    district:'行政区',
    business:"商業区",
    ThePassengerInformation:"旅客情報",
    NewTrainInformation:'新しい列車情報',
    OriginalTrainInformation:'元の列車情報',
    NewFlightInformation:'新しいフライト情報',
    OriginalFlightInformation:'元のフライト情報',
    NextStep:'次へ',
    ChangeDate:'変更日',
    SelectChangeFlight:"変更するフライトを選択してください",
    SelectRefundFlight:"払い戻しするフライトを選択してください",
    SelectChangeTrain:"変更する旅客を選択してください",
    SelectRefundTrain:"払い戻しする旅客を選択してください",
    SelectRefundHotel:'チェックアウトするホテルを選択してください',
    SelectChangeDate:'変更日を選択してください',
    Department:'部門',
    ApprovalStatus:"承認ステータス",
    ConfidentialInformation:"証憑情報",
    TradeInformation:'取引情報',
    Insurance:'保険',
    Home:'ホーム',
    Stroke:"旅程",
    Me:"マイページ",
    TravelApproval:"出張承認",
    TravelRulesName:"出張ルール名",
    MinimumPriceBase:"最低価格基準",
    RealFlightControl:"リアルタイムフライト管理",
    AdvanceBookingTime:"事前予約時間",
    ClassLimit:'クラス制限',
    SeatClassLimit:"座席クラス制限",
    AgreementAirlinePriority:'契約航空券優先',
    AgreementHotelPriority:"契約ホテル優先",
    MaximumAmountConsumption:'消費金額上限',
    ApprovalName:'承認名',
    Other:'その他',
    FirstClassCity:"一級都市",
    SecondaryCity:"二級都市",
    ThreeLevelCity:"三級都市",
    SeatSelectionService:"座席指定サービス",
    Bezel:"窓側",
    Aisle:"通路側",
    NewContacts:"連絡先追加",
    AdditionalInvoiceInformation:"請求書情報の追加/編集",
    InvoiceInformation:"請求書情報",
    InvoiceTitle:"請求書の宛名",
    TariffItem:'税番号',
    SetDefaultContacts:"デフォルトの連絡先を設定",
    ConsigneeAddress:"受取住所",
    NewCommonAddresses:"よく使う住所を追加",
    default:'デフォルト',
    City:'都市',
    Address:"住所",
    Postcode:'郵便番号',
    AddCommonAddresses:"よく使う住所を追加/編集",
    DepartureTime:'出発時間',
    Airport:'空港',
    ShippingSpace:'クラス',
    AirlineCompany:'航空会社',
    '150OrLess': "150元以下",
    '150And300': "150元〜300元",
    '300And450': "300元〜450元",
    '450And600': "450元〜600元",
    '600OrMore': "600元以上",
    TwoStarsOrLess:"二つ星以下",
    ThreeStar:"三つ星/コンフォート",
    FourStar:"四つ星/高級",
    FivesStar:"五つ星/ラグジュアリー",
    Apartment:'アパート',
    Inn:"民宿",
    FamilyInn:"ファミリー向け宿泊施設",
    YouthHostel:'ユースホステル',
    CoupleHotel:"カップル向けホテル",
    GardenCourtyard:"庭園",
    SeaView:"オーシャンビュー",
    Farmhouse:"農家楽",
    HotSpringHotel:'温泉ホテル',
    GolfHotel:'ゴルフホテル',
    Siheyuan:'四合院',
    Villa:'別荘',
    PartyCooking:"パーティー・自炊",
    BusinessTtravelHome:"ビジネス向け宿",
    LeisureMood:"リラックスした雰囲気",
    SeeDoctor:"通院・治療",
    VacationLeisure:"リゾート・レジャー",
    TrainAndLearn:"研修・学習",
    GetTogether:'パーティー',
    HoneymoonTrip:"ハネムーン旅行",
    boutiqueHotel:"ブティックホテル（デザイナーズホテル）",
    FreeWifi:"無料Wi-Fi",
    FreeParking:'無料駐車場',
    IndoorPool:"屋内プール",
    OutdoorPool:"屋外プール",
    service:'ジム',
    BusinessCenter:'ビジネスセンター',
    MeetingRoom:'会議室',
    HotelRestaurant:"ホテルレストラン",
    MorningCall:'モーニングコール',
    LuggageStorage:"手荷物預かり",
    TwinBed:"ツインベッド",
    BigBed:"ダブルベッド",
    FreePickUpService:"無料空港送迎サービス",
    Price:'価格',
    StarLevel:"星ランク",
    Specialtie:"特色",
    Service:"施設・サービス",
    DetailsOrFacilities:'詳細/施設',
    HotelDetail:"ホテル詳細",
    ModelSelection:"機種選択",
    HighSpeedRail:"高速鉄道(G/C)",
    MotorCar:'動車(D)',
    Ordinary:'普通列車(Z/T/K)',
    DepartureOrArrival:'出発/到着駅',
    Date:'日付',
    Status:"ステータス",
    OldSystem:'PC版でご覧ください',
    Welcome:'ようこそ',
    PleaseLogIn:'ログインしてください',
    FlightTips:"格安航空券、快適な旅",
    HotelTips:"プレミアム宿泊、ビジネス旅行専用",
    TrainTips:"ワンクリックで即時発券",
    TourTips:"厳選特価ツアー",
    Invoice:"請求書の宛名",
    InvoiceType:'領収書の種類',
    Identifier:"識別番号",
    TicketInquiry:"航空券検索",
    TrainInquiry:"列車検索",
    HotelInquiry:"ホテル検索",
    ConsumerHotline:"カスタマーサービス電話番号",
    WeChatService:'WeChatカスタマーサービス',
    TravelPolicy:"出張規定",
    EditData:"プロフィール編集",
    RecommendFlight:"おすすめフライト",
	voyageinfos: "フライト情報",
	passinfos: "乗客情報",
    passnum: "乗客人数",
	cabinlevel: "クラス",
	consumertype: "乗客タイプ",
	sui: "歳",
    twosui: "2歳未満",
    firstairway: "優先航空会社",
	demandprobtip: "送信に問題がある場合はお問い合わせください：",
	submit: "送信",
	remark: "備考",
	email: "メールアドレス",
	contact: "連絡先",
	phoneno: "携帯電話番号",
	contactinfo: "連絡先情報",
	normal: "一般",
    student: "学生",
    newimmigrant: "新移民",
    worker: "労務",
	adult: "大人",
    child: "子供",
    infant: "乳児",
	departcity: "出発都市",
    arrivecity: "到着都市",
    departdate: "出発時間",
    arrivedate: "到着時間",
	selectdate: "日付を選択してください",
	delete: "削除",
	addvoyage: "フライトを追加",
	notificationMessageFlight:"通知：必要に応じて、ここをクリックして国際リクエストリストにアクセスし、より多くの格安国際航空券をご利用いただけます。あらゆる出張ニーズに対応いたします。お電話でもお問い合わせいただけます：",
	noVoyage:"条件に合うフライトが見つかりませんか？",
	foundRequirement:"リクエストリストを作成",
	Hotline: "ホットラインで相談。",
    OriginalFlight:'元のフライト',
    More:"もっと見る",
    MoreInfo:"詳細情報",
    Hidden:'隠す',
    JetFuel:"空港建設費・燃油サーチャージ込み",
    Booking:'予約',
    CurrentPosition:"現在地",
    Room:'部屋',
    SquareMeters:'平方メートル',
    CanLive:"宿泊可能",
    Floor:"階",
    Layer:'階',
    ServiceFee:'サービス料',
    InsurancePremium:'保険料',
    Yuan:"元",
    ContactHotel:"ホテルに連絡",
    After:'後',
    Before:'前',
    For:"に",
    DueTo:"予約日",
    ViolationPolicy:"規則違反",
    CompliancePolicy:"ルールに合致",
    BusinessInformation:"ビジネス旅行情報",
    Within:'以内',
    RefuseReason:"承認コメント",
    Against:"違反しました",
    Policy:'のポリシー',
    DetailedReason:'詳細理由',
    Wait:"待機",
    Approval:'承認',
    Breach:'違反',
    AirlineAuditStandards:"航空会社の最新規定に準じます。カスタマーサービスホットラインまでお問い合わせください。",
    ConfirmOrder:"注文確認",
    FlightInformation:"フライト情報",
    Voyage:"フライト行程",
    DeparturePlace:"出発地",
    ArrivePlace:"到着地",
    AddVoyage:"フライトを追加",
    PassengersNumbers:"乗客人数",
    ShipType:"座席クラス",
    PassengersType:'乗客タイプ',
    ShipCompany:'優先航空会社',
    Remarks:"備考",
    PackUp:"閉じる",
    Show:"展開する",
    DocumentType:'証明書の種類',
    CardNo:"身分証明書番号",
    InvoiceRole:"請求書の役割",
    BankName:'銀行名',
    BankAccount:"銀行口座番号",
    RegisteredAddress:'登録住所',
    RegisteredPhone:'登録電話',
    ChangeReason:'変更理由',
    VoucherNumber:"伝票番号",
    CancelReason:'キャンセル理由',
    ChildInfantBooking:"子供・幼児の予約説明",
    boyin:'ボーイング',
    kongke:'エアバス',
    AppropriationBudget:'経費予算',
    Attendance:"参加人数",
    HostPlace:"開催場所",
    Destination:'目的地',
    ParticipantsNumber:"参加人数",
    ActivityBudget:'活動予算',
    AmountPaid:"支払い金額",
    ConfirmPayment:"支払い確認",
    Pay:"支払う",
    PriceTxt:"価格",
	ReserveHint:"現在は非連絡便のため、いずれかのフライトに変更が生じた場合、もう一方のフライトの払い戻しや変更が必要な場合、乗客は自身で相応の払い戻し・変更手数料を負担する必要があります。",
    EmptyData:"条件に一致する結果が見つかりませんでした。日付または都市を変更して再検索することをお勧めします。",
	TicketFare:"券面額",
	BuildFare:"空港使用料",
	FuelFare:"燃油サーチャージ",
	TaxFare:"税金",
  },
  placeholders: {
    UserID:'ユーザー名を入力してください',
    Password:'パスワードを入力してください',
    UserPhone:"携帯電話番号を入力してください",
    contacts:"連絡先の氏名を入力してください",
    Email:"確認書の受信用",
    CostCenter:'コストセンターを選択してください',
    TravelPurpose:"出張目的を選択してください",
    ProjectCode:'プロジェクトコードを入力してください',
    CauseName:"違反理由を選択してください",
    CauseDetails:"詳細な違反理由を記入してください",
    searchTraveller:"氏名を入力してください",
    SearchZones:"都市名、駅名の中国語またはピンイン",
    UserName:"証明書の氏名と一致",
    LastName:"例：張飛の場合、「ZHANG」と記入",
    firstName:"例：張飛の場合、「FEI」と記入",
    CardNo:"所持証明書番号",
    Phone:'携帯電話番号を入力してください',
    RecipientAddress:"受取人の住所を入力してください",
    RecipientPostcode:"受取人の郵便番号を入力してください",
    OriginalPassword:"現在のパスワードを入力してください",
    NewPassword:'新しいパスワードを入力してください',
    AffirmNewPassword:'パスワードを確認してください',
    CompanyName:"企業名を入力してください",
    SelectCity:'都市を選択してください',
    Industry:'業界を入力してください',
    Account:"携帯電話番号またはメールアドレスを入力してください",
    VerificationCode:"認証コードを入力してください",
    DynamicCode:'動的コードを入力してください',
    RegisterPhone:"携帯電話番号を登録または紐付けてください！",
    Invoice:"請求書の宛名",
    InvoiceType:'領収書の種類',
    Identifier:"必須、納税者識別番号",
    RefusalCause:"拒否理由を入力してください",
    CaseInsensitive:'大文字と小文字を区別しません',
    MessageAuthenticationCode:"SMS認証コード",
    DeparturePlace:"出発地",
    ArrivePlace:"到着地",
    ContactEmail:'メールアドレスを入力してください',
    Remarks:"備考を入力してください",
    ShipCompany:'優先航空会社',
    BankName:'銀行名',
    BankAccount:"銀行口座番号",
    RegisteredAddress:'登録住所',
    RegisteredPhone:'登録電話',
    TrainDetailReason:"列車詳細理由",
    PeopleNumber:'人数を入力してください',
    AppropriationBudget:"予算経費を入力してください",
    ContactNumber:"連絡先電話番号を入力してください",
    ContactRemarks:"ご都合の良い連絡時間と方法をお知らせください。最適な時間にご返信いたします。",
  },
  system: {
    Customer:"オンラインカスタマーサービス",
    EmailNotification:"メール通知",
    servicePhone:"400-088-8020",
    Company:"力程商旅",
    Name:"力程商旅",
    contacts:"連絡先情報",
    HowToCall:"どのようにお呼びすればよろしいですか",
    PerfectInformation:"携帯電話番号を入力してください",
    BindingPhone:"携帯電話番号を紐付け",
    BindingEmail:"メールアドレスを紐付け",
    AccountAssociated:"アカウント連携",
    UpdatePassword:"ログインパスワードを変更",
    Language:'言語',
    Chinese:"中",
		English:"英",
		Japanese:"日",
    ExitLogin:"ログアウト",
    WeChat:"微信",
    ImmediatelyBinding:'今すぐバインド',
    Password:'パスワード',
    OriginalPassword:'元のパスワード',
    NewPassword:'新しいパスワード',
    AffirmNewPassword:"パスワード確認",
    ChangePassword:"パスワード変更",
    EditPersonalInformation:"プロフィール編集",
    CompanyName:"企業名",
    Industry:'業界',
    Account:"マイアカウント",
    VerificationCode:"認証コード",
    DynamicCode:'動的コード',
    RegisterNow:'今すぐ登録',
    Register:'登録',
    UserRegister:'個人登録',
    CompanyRegister:'企業登録',
    ServiceAgreement:"「力程旅行網サービス規約」に同意する",
    SendDynamicCode:"動的コードを送信",
    Sent:"送信済み",
    LoginTxt:"ログイン",
    DynamicPasswordLogin:'動的パスワードログイン',
    ForgetPassword:"パスワードをお忘れですか",
    Integral:'ポイント',
    AllOrders:'すべての注文',
    Obligation:'支払い待ち',
    NotToTravel:"未旅行",
    ToApproval:'承認待ち',
    TicketInformation:'チケット情報',
    OrderInformation:'注文情報',
    OrderID:'注文番号',
    TradeID:'取引番号',
    TradeAmount:"注文総額",
    CollectingCompany:"受取会社",
    PaymentWays:'支払方法',
    Payment:"支払い",
    ThePassengerInformation:"旅客情報",
    PassWordLogin:'パスワードログイン',
    CodeLogin:"認証コードログイン",
    Notice:"通知",
    RecentOrders:"近日の旅程",
    Reserved:"予約手配待ち",
    CustomerService:'カスタマーサービス',
    Sell:"販売",
    ContactUs:"お問い合わせ",
    Call:"通話",
    ServiceDept:"カスタマーサービス部",
    MyOrder:"マイオーダー",
    ApprovalDispose:'承認処理',
    RetrievePwd:"ログインやパスワード再設定に便利です",
    ElectronicBills:"電子請求書の受取に便利です",
    ApprovalAccredit:"承認権限",
    AboutUs:"当社について",
    TestGetCode:"認証コードを取得",
    PhoneHint:"登録済みの携帯電話でパスワードをリセットできます。",
    EmailHint:"バインドされたメールアドレスでパスワードをリセットできます。",
    LoginPassword:'ログインパスワード',
    ResetPassword:"パスワードをリセット",
    EnterAccount:"アカウントを入力",
    PhoneVerification:"携帯電話認証",
    EmailVerification:"メール認証",
    SetBinding:"バインド設定",
    Input:'入力',
    Effective:'有効な',
    Verify:"認証",
    NextStep:'次へ',
    RemarkString:"変更・キャンセル期限",
    RefundFee:'キャンセル料',
    Cabinfee:"同一クラス変更手数料",
    ReimburseInfo:"経費精算情報",
    BaggageAllowance:"受託手荷物許容量",
    BackChangeRemark:"上記の大人の払い戻し・変更規則及び手数料基準は参考情報であり、実際には航空会社の規定に準じます。",
    PartRoute:"一部路線",
    PartHotel:"一部ホテル",
    IsSaveCustomers:"マイレージ会員を保存しますか",
    EmployeeRights:"従業員権限",
    DateGranted:'付与日',
    ExpiryDate:"有効期限",
    AddApproval:"承認の追加/修正",
    AddApprovals:'承認を追加',
    DownloadInstall:'ダウンロードとインストール',
    TopRightCorner:"右上の角をクリックしてください",
    BrowserOpen:"「ブラウザで開く」を選択",
    CannotDownloaded:"WeChat/QQ内ではアプリをダウンロードできません",
    CompanyProfile:'会社概要',
    CompanyProfileContent:"上海力程公式サイト(www.lichengtrip.net)は上海力程票務有限公司に所属し、本社は中国上海にあり、本社オフィスは上海市長寧区の新東紡国際ビジネスセンターに位置し、静安寺や曹家渡などのビジネス中心地に隣接しています。社内にはコールセンター、総経理室、財務部、票務決済部、国際部、国内同業部、カスタマーサービス部、研修部、商務部、運営センターなどの関連部門が設置されています。上海で販売範囲が広く、サービス規模が大きく、総合力の強い大型民用航空サービス企業です。",
    FutureProspects:"将来の展望",
    FutureProspectsContent:"インターネット技術が急速に発展する21世紀において、上海力程は科学研究機関と共同で開発したビジネストラベル流通システムを用い、独立した知的財産権を持つ先進技術で、便利で迅速な流線型のエンジニアリングを通じて、天下の民衆生活のあらゆる面にサービスを提供し、ネットワーク社会に生きるすべての一般市民に、ネット経済の大波に乗るチャンスを与えています。彼らが刻一刻のネット生活体験の中で、中華民族の優れた伝統文化と現代の民主的なライフスタイルの完璧な融合を感じ、実質的な人間愛と物質生活の絶え間ない豊かさと向上を実感できるようにし、ネットワーク社会の健全で調和のとれた安定した発展を推進するために、力程人のすべての情熱と知恵を捧げます！2016年は力程がさらなる発展を迎える時であり、革新と進取を原動力に、発展速度をさらに加速させ、発展の質を高め、国際・国内航空券販売を主体とし、休暇予約も並行して進め、全面的な発展戦略を実施し、情報化の推進と情報プラットフォームの構築に力を入れます。",
    ManagementTeam:"緊密に精進する管理チーム",
    ManagementTeamContent:"上海力程の管理チームは、資源提携、管理スキル、業務経験における完璧な組み合わせ、そしてチーム間の緊密で適切な協力により、会社の迅速で健全な発展を保証しています。当社の上級管理チームは、国際IT業界、観光業界及び金融業界における長年の業務運営と管理の経験を結集しています。中間管理チームは、中国のIT業界、航空代理業界及び観光業界の人材を結集し、サービス規模化と資源規模化の管理方針を保証しています。",
    TechnicalService:"技術リードとサービス",
    TechnicalServiceContent:"力程は常に技術革新を企業の活力の源泉と見なし、研究開発能力の向上に余念がありません。力程は一連の近代的なサービスシステムを構築し、革新と進取を原動力に、発展速度をさらに加速させ、発展の質を高め、国際・国内航空券販売を主体とし、ホテル予約、休暇予約も並行して進め、全面的な発展戦略を実施し、情報化の推進と情報プラットフォームの構築に力を入れています。",
    AboutUsContent:'電話：400-088-8020',
  },
  share: {
    hot:'人気',
    calendarDataTitle:'日付を選択',
    calendarDataExplain:"照会日付は出発日です",
    cancelTxt:'キャンセル',
    confirmTxt:"確定",
    pullUpLoadMoreTxt:"さらに読み込む",
    pullUpLoadNoMoreTxt:"これ以上ありません",
    RefreshTheSuccess:'リフレッシュ成功',
    Save:"保存",
    Add:'追加',
    QueryBtn:"照会",
    SubmitBtn:"送信",
    AmendBtn:'修正',
    FinishBtn:"完了",
    fail: {
      CancelOrder:"キャンセルする注文を選択してください",
      RefundOrder:"キャンセルする払い戻し注文を選択してください",
      selectTraveller:"搭乗者を選択してください！",
      minPrice:"選択されたのは推奨フライトまたはクラスではありません。予約を続行しますか？",
      CostCenter:'コストセンターを入力してください！',
      TravelPurpose:"出張目的を入力してください！",
      EnglishName:"この搭乗者には英語名がありません！",
      RefundJourney:"払い戻しが必要な旅程を選択してください！",
      RefundReason:"払い戻しの理由を選択してください！",
      RefundTraveller:"払い戻しが必要な搭乗者を選択してください！",
      ChangeJourney:"変更が必要な旅程を選択してください！",
      ChangeTraveller:"変更が必要な搭乗者を選択してください！",
      ChooseAnotherFlight:'他の航空会社のフライトを選択してください！',
      TheCorrectName:"正しい姓と名を入力してください！",
      UsreNameRepetition:"搭乗者名は重複できません！",
      RegisterPhone:"携帯電話番号を登録または紐付けてください！",
      VerificationCode:"認証コードを入力してください",
      DynamicCode:'動的コードを入力してください',
      PassengerSurname:"搭乗者の姓を入力してください",
      PassengerName:"搭乗者の名を入力してください",
      RefusalCause:"拒否理由を記入してください！",
      PhoneBinding:"紐付けられた携帯電話番号は空にできません",
      EmailBinding:"紐付けられたメールアドレスは空にできません",
      Phone:"正しい携帯電話番号を入力してください",
      Email:"正しいメールアドレスを入力してください",
      VerificationTime:"認証コードは60秒ごとに1回のみ取得できます",
      Account:"アカウントを入力してください",
      AccountEmpty:"アカウントは空にできません",
      PasswordEmpty:"パスワードは空にできません",
      PassengersNumbers:"乗客数が上限に達しました。カスタマーサービスにお問い合わせください",
      ManyPeople:"人数が多すぎます。団体購入についてはカスタマーサービスにお問い合わせください",
      ChangeReason:"変更理由は空にできません",
      SeatNumbers:"乗客数が選択座席数を超えています",
      SelectSeat:'選択した乗客の座席を選択してください',
    },
    succ: {
      SaveSucc:"保存成功！",
      CancelSucc:"キャンセル成功！",
      ApprovalRefused:"承認拒否！",
      ApproveSucc:"承認通過！",
      RefundSucc:'払い戻し申請が正常に送信されました',
      ChangeSucc:"変更申請の提出に成功しました！",
      RegisteredSucc:"登録成功！",
      LoginSucc:'ログイン成功！',
      ChangePasswordSucc:"パスワード変更成功",
      VerificationSucc:"認証コード送信成功",
      AddSucc:"追加成功",
      ModifySucc:"変更成功",
      DeleteSucc:"削除成功",
      WeChat:"WeChat連携解除成功",
    },
    confirm: {
      YesOrNoDelect:"削除してもよろしいですか",
      CreateOrder:"注文が正常に作成されました。注文詳細でいつでも注文の進捗状況を確認できます",
      ThankRemarks:"日頃より力程商旅をご愛顧いただき、誠にありがとうございます。ユーザーの出張体験をより向上させるため、力程商旅は2018年10月30日午前9時より、力程商旅2.0システムを正式にリリースいたします。ユーザーはApp Storeから自動更新が可能です。Androidシステムの場合は、弊社カスタマーサービスまでお問い合わせください。緊急連絡先：15901610043。ありがとうございます！",
    },
    loading: {
      load:"読み込み中",
      creatOrder:"注文作成中",
      PriceCalculation:"料金計算中",
    },
  },
  Categorys: {
    Young:'大人',
    Enfant:"子供",
    Infant:'乳児',
    economyClass:'エコノミークラス',
    buissenesClass:'ビジネスクラス',
    firstClass:'ファーストクラス',
    OnBusiness:"業務用",
    OnPersonal:"私用",
    FlightService:'航空券',
    HotelService:'ホテル',
    TourService:'旅行',
    TrainService:"電車",
    SingleVoyage:'片道',
    RoundVoyage:'往復',
    WaitBooking:'予約待ち',
    WaitConfirm:'確認待ち',
    WaitPayment:'支払い待ち',
    WaitDispose:'処理待ち',
    Finished:"完了",
    Canceled:"キャンセル済み",
    Rejected:"返却済み",
    Cannot:"現在不可",
    WaitApprove:'承認待ち',
    Discrete:"分割済み",
    WaitSubmit:'提出待ち',
    WaitRefund:"返金待ち",
    Male:"男性",
    Female:"女性",
    IDCard:'身分証明書',
    PassportCard:'パスポート',
    StudentCard:"学生証",
    OfficerCard:"軍人手帳",
    HKMpermit:"帰郷証",
    TaiWpermit:'台湾同胞証',
	HKCompatriotsyndrome: "香港・マカオ通行証",
	TaiCompatriotsyndrome: "台湾通行証",
	Residencepermit: "香港・マカオ・台湾居民居住証",
	ForeignResidentIDCard: "外国人永久居留身分証",
    OtherCard:'その他',
    Company:'会社',
    User:'ユーザー',
    HotelFare:"宿泊料金",
    TicketFare:"券面額",
    MobileAuth:"携帯電話アカウント",
    EmailAuth:"メールアカウント",
    AccountAuth:'アカウントパスワード',
    WeixinAuth:'WeChat認証',
    DynamicAuth:'動的パスワード',
    MessageNotify:'SMS通知',
    MailNotify:"メール通知",
    WechatNotify:'WeChat通知',
    AppNotify:'アプリ通知',
    Normal:"一般",
    OverseasStudent:'学生',
    Worker:'労務',
    Immigrant:"新移民",
    '1138Categorys': "身分証明書",
    '1139Categorys': 'パスポート',
    '1140Categorys': "学生証",
    '1141Categorys': "軍人手帳",
    '1298Categorys': "帰郷証",
    '1299Categorys': '台湾同胞証',
    '1233Categorys': '台湾通行証',
    '1234Categorys': "香港・マカオ通行証",
    // '1142Categorys': '其它',
    AmendingFlight:"一部払い戻し処理中",
    ChangeingFlight:"一部変更処理中",
    AmendingTrain:"一部払い戻し処理中",
    ChangeingTrain:"一部変更処理中",
    AmendingHotel:"一部屋チェックアウト中",
    ChangeingHotel:"一部変更処理中",
    AmendingTour:"一部ツアーキャンセル中",
    ChangeingTour:"一部変更処理中",
    AmendedFlight:"一部チケット払い戻し",
    ChangeedFlight:"一部変更手続き",
    AmendedTrain:"一部チケット払い戻し",
    ChangeedTrain:"一部変更手続き",
    AmendedHotel:"一部屋チェックアウト",
    ChangeedHotel:"一部変更手続き",
    AmendedTour:"一部ツアーキャンセル",
    ChangeedTour:"一部変更手続き",
    AllAmendingFlight:"チケット払い戻し中",
    AllChangeingFlight:"変更手続き中",
    AllBookingFlight:"チケット購入中",
    AllAmendingTrain:"チケット払い戻し中",
    AllChangeingTrain:"変更手続き中",
    AllBookingTrain:"チケット購入中",
    AllAmendingHotel:'チェックアウト中',
    AllChangeingHotel:"変更手続き中",
    AllBookingHotel:'予約中',
    AllAmendingTour:"ツアーキャンセル中",
    AllChangeingTour:"変更手続き中",
    AllBookingTour:'予約中',
    AllAmendedFlight:"チケット払い戻し成功",
    AllChangeedFlight:"変更手続き成功",
    AllBookedFlight:"チケット購入成功",
    AllAmendedTrain:"チケット払い戻し成功",
    AllChangeedTrain:"変更手続き成功",
    AllBookedTrain:"チケット購入成功",
    AllAmendedHotel:'チェックアウト成功',
    AllChangeedHotel:"変更手続き成功",
    AllBookedHotel:'予約成功',
    AllAmendedTour:"ツアーキャンセル成功",
    AllChangeedTour:"変更手続き成功",
    AllBookedTour:'予約成功',


  },
  RegExp: {
    AccountReg: {
      isEmpty:"アカウントは空にできません",
      isFormat:"アカウントの形式が正しくありません",
    },
    PwdReg: {
      isEmpty:"パスワードは空にできません",
      isFormat:'パスワードの形式が正しくありません',
    },
    ConfigPwd: {
      isEmpty:"パスワードは空にできません",
      isFormat:"パスワードが一致しません",
    },
    VerificationCodeReg: {
      isEmpty: "認証コードは空にできません",
    },
    DynamicCodeReg: {
      isEmpty: "動的コードは空にできません",
    },
    ProtocolReg: {
      isFlag: "規約に同意する必要があります"
    }
  },
	"mall_flight_flight_shenqingyuding": "貴社のOAシステムにアクセスして予約申請を行ってください",
	"mall_hotel_hotel_shenqingyuding": "貴社のOAシステムにアクセスして予約申請を行ってください",
	"mall_hotel_hoteldetails_youchuang": "窓あり",
	"mall_hotel_hoteldetails_wuchuang": "窓なし",
	"mall_hotel_hoteldetails_xianshiquxiao": "期間限定キャンセル",
	"mall_hotel_hotellist_wukeyudingfangxing": "予約可能な部屋タイプはありません",
	"mall_modules_producthome_yes": "はい",
	"mall_modules_producthome_no": "いいえ",
	"mall_modules_producthome_buxianzhi": "制限なし",
	"mall_modules_producthome_xiangduizuidijia": "相対最安値",
	"mall_modules_producthome_quantianzuidijia": "終日最安値",
	"mall_modules_producthome_shiduanzuidijia": "時間帯最安値",
	"mall_modules_producthome_hangbanzuidijia": "フライト最安値",
	"mall_modules_productlist_fudongfeilvshangxian": "変動料率上限：",
	"mall_modules_productlist_fudongjineshangxian": "変動金額上限：",
	"mall_modules_productlist_gongxianghangban": "コードシェア便",
	"mall_modules_productlist_yincanggongxianghangban": "コードシェア便を非表示",
	"mall_order_xiaofeijineshangxian": "消費金額上限",
	"mall_order_dangdizhusubiaozhun": "現地宿泊費基準",
	"mall_order_shenpiren": "承認者",
	"mall_order_qingxuanzeshenpiren": "承認者を選択してください",
	"mall_train_train_shenqingyuding": "貴社のOAシステムにアクセスして予約申請を行ってください",
	"order_flight_flightdetail_yi": "一",
	"order_flight_flightdetail_er": "二",
	"order_orderdetails_wu": "五",
	"order_orderdetails_yiquxiao": "キャンセル済み",
	"order_orderdetails_daishenpi": "承認待ち",
	"order_orderdetails_tuifangchulizhong": "チェックアウト処理中",
	"order_orderdetails_tuituanchulizhong": "退団処理中",
	"order_orderdetails_tuipiaochulizhong": "払い戻し処理中",
	"order_orderdetails_youtuifang": "チェックアウトあり",
	"order_orderdetails_youtuituan": "退団あり",
	"order_orderdetails_youtuipiao": "払い戻しあり",
	"order_orderdetails_gaiqianchulizhong": "変更手続き中",
	"order_orderdetails_yougaiqian": "変更あり",
	"order_orderdetails_quanbutuifang": "全員チェックアウト",
	"order_orderdetails_quanbutuifangzhong": "全員チェックアウト中",
}
